export const locales = [
    {
        name: 'US',
        officialName: 'United States of America',
        numeric: '840',
        alpha2: 'US',
        alpha3: 'USA',
        currencyName: 'US Dollar',
        currencyAlphabeticCode: 'USD',
        langName: 'English (United States)',
        langIso: 'en_US',
    },
    {
        name: 'Spain',
        officialName: 'Spain',
        numeric: '724',
        alpha2: 'ES',
        alpha3: 'ESP',
        currencyName: 'Euro',
        currencyAlphabeticCode: 'EUR',
        langName: 'Spanish (Spain)',
        langIso: 'es_ES',
    },
    {
        name: 'Germany',
        officialName: 'Germany',
        numeric: '276',
        alpha2: 'DE',
        alpha3: 'DEU',
        currencyName: 'Euro',
        currencyAlphabeticCode: 'EUR',
        langName: 'German (Germany)',
        langIso: 'de_DE',
    },
    {
        name: 'France',
        officialName: 'France',
        numeric: '250',
        alpha2: 'FR',
        alpha3: 'FRA',
        currencyName: 'Euro',
        currencyAlphabeticCode: 'EUR',
        langName: 'French (France)',
        langIso: 'fr_FR',
    },
    {
        name: 'China',
        officialName: 'China',
        numeric: '156',
        alpha2: 'CN',
        alpha3: 'CHN',
        currencyName: 'Yuan Renminbi',
        currencyAlphabeticCode: 'CNY',
        langName: 'Chinese Simplified',
        langIso: 'zh_CN',
    },
    {
        name: 'Portugal',
        officialName: 'Portugal',
        numeric: '620',
        alpha2: 'PT',
        alpha3: 'PRT',
        currencyName: 'Euro',
        currencyAlphabeticCode: 'EUR',
        langName: 'Portuguese (Portugal)',
        langIso: 'pt_PT',
    },
    {
        name: 'Russia',
        officialName: 'Russian Federation',
        numeric: '643',
        alpha2: 'RU',
        alpha3: 'RUS',
        currencyName: 'Russian Ruble',
        currencyAlphabeticCode: 'RUB',
        langName: 'Russian (Russia)',
        langIso: 'ru_RU',
    },
    {
        name: 'Taiwan',
        officialName: null,
        numeric: '158',
        alpha2: 'TW',
        alpha3: 'TWN',
        currencyName: null,
        currencyAlphabeticCode: null,
        langName: 'Chinese Traditional',
        langIso: 'zh_TW',
    },
    {
        name: 'Afghanistan',
        officialName: 'Afghanistan',
        numeric: '004',
        alpha2: 'AF',
        alpha3: 'AFG',
        currencyName: 'Afghani',
        currencyAlphabeticCode: 'AFN',
        langName: 'Persian (Afghanistan)',
        langIso: 'fa_AF',
    },
    {
        name: 'Afghanistan',
        officialName: 'Afghanistan',
        numeric: '004',
        alpha2: 'AF',
        alpha3: 'AFG',
        currencyName: 'Afghani',
        currencyAlphabeticCode: 'AFN',
        langName: 'Turkmen (Afghanistan)',
        langIso: 'tk_AF',
    },
    {
        name: 'Albania',
        officialName: 'Albania',
        numeric: '008',
        alpha2: 'AL',
        alpha3: 'ALB',
        currencyName: 'Lek',
        currencyAlphabeticCode: 'ALL',
        langName: 'Albanian (Albania)',
        langIso: 'sq_AL',
    },
    {
        name: 'Albania',
        officialName: 'Albania',
        numeric: '008',
        alpha2: 'AL',
        alpha3: 'ALB',
        currencyName: 'Lek',
        currencyAlphabeticCode: 'ALL',
        langName: 'Greek (Albania)',
        langIso: 'el_AL',
    },
    {
        name: 'Algeria',
        officialName: 'Algeria',
        numeric: '012',
        alpha2: 'DZ',
        alpha3: 'DZA',
        currencyName: 'Algerian Dinar',
        currencyAlphabeticCode: 'DZD',
        langName: 'Arabic (Algeria)',
        langIso: 'ar_DZ',
    },
    {
        name: 'American Samoa',
        officialName: 'American Samoa',
        numeric: '016',
        alpha2: 'AS',
        alpha3: 'ASM',
        currencyName: 'US Dollar',
        currencyAlphabeticCode: 'USD',
        langName: 'English (American Samoa)',
        langIso: 'en_AS',
    },
    {
        name: 'American Samoa',
        officialName: 'American Samoa',
        numeric: '016',
        alpha2: 'AS',
        alpha3: 'ASM',
        currencyName: 'US Dollar',
        currencyAlphabeticCode: 'USD',
        langName: 'Samoan (American Samoa)',
        langIso: 'sm_AS',
    },
    {
        name: 'American Samoa',
        officialName: 'American Samoa',
        numeric: '016',
        alpha2: 'AS',
        alpha3: 'ASM',
        currencyName: 'US Dollar',
        currencyAlphabeticCode: 'USD',
        langName: 'Tongan (American Samoa)',
        langIso: 'to_AS',
    },
    {
        name: 'Andorra',
        officialName: 'Andorra',
        numeric: '020',
        alpha2: 'AD',
        alpha3: 'AND',
        currencyName: 'Euro',
        currencyAlphabeticCode: 'EUR',
        langName: 'Catalan (Andorra)',
        langIso: 'ca_AD',
    },
    {
        name: 'Angola',
        officialName: 'Angola',
        numeric: '024',
        alpha2: 'AO',
        alpha3: 'AGO',
        currencyName: 'Kwanza',
        currencyAlphabeticCode: 'AOA',
        langName: 'Portuguese (Angola)',
        langIso: 'pt_AO',
    },
    {
        name: 'Argentina',
        officialName: 'Argentina',
        numeric: '032',
        alpha2: 'AR',
        alpha3: 'ARG',
        currencyName: 'Argentine Peso',
        currencyAlphabeticCode: 'ARS',
        langName: 'Spanish (Argentina)',
        langIso: 'es_AR',
    },
    {
        name: 'Argentina',
        officialName: 'Argentina',
        numeric: '032',
        alpha2: 'AR',
        alpha3: 'ARG',
        currencyName: 'Argentine Peso',
        currencyAlphabeticCode: 'ARS',
        langName: 'English (Argentina)',
        langIso: 'en_AR',
    },
    {
        name: 'Argentina',
        officialName: 'Argentina',
        numeric: '032',
        alpha2: 'AR',
        alpha3: 'ARG',
        currencyName: 'Argentine Peso',
        currencyAlphabeticCode: 'ARS',
        langName: 'Italian (Argentina)',
        langIso: 'it_AR',
    },
    {
        name: 'Argentina',
        officialName: 'Argentina',
        numeric: '032',
        alpha2: 'AR',
        alpha3: 'ARG',
        currencyName: 'Argentine Peso',
        currencyAlphabeticCode: 'ARS',
        langName: 'German (Argentina)',
        langIso: 'de_AR',
    },
    {
        name: 'Argentina',
        officialName: 'Argentina',
        numeric: '032',
        alpha2: 'AR',
        alpha3: 'ARG',
        currencyName: 'Argentine Peso',
        currencyAlphabeticCode: 'ARS',
        langName: 'French (Argentina)',
        langIso: 'fr_AR',
    },
    {
        name: 'Argentina',
        officialName: 'Argentina',
        numeric: '032',
        alpha2: 'AR',
        alpha3: 'ARG',
        currencyName: 'Argentine Peso',
        currencyAlphabeticCode: 'ARS',
        langName: 'Guaran­i (Argentina)',
        langIso: 'gn_AR',
    },
    {
        name: 'Armenia',
        officialName: 'Armenia',
        numeric: '051',
        alpha2: 'AM',
        alpha3: 'ARM',
        currencyName: 'Armenian Dram',
        currencyAlphabeticCode: 'AMD',
        langName: 'Armenian (Armenia)',
        langIso: 'hy_AM',
    },
    {
        name: 'Aruba',
        officialName: 'Aruba',
        numeric: '533',
        alpha2: 'AW',
        alpha3: 'ABW',
        currencyName: 'Aruban Florin',
        currencyAlphabeticCode: 'AWG',
        langName: 'Dutch (Aruba)',
        langIso: 'nl_AW',
    },
    {
        name: 'Aruba',
        officialName: 'Aruba',
        numeric: '533',
        alpha2: 'AW',
        alpha3: 'ABW',
        currencyName: 'Aruban Florin',
        currencyAlphabeticCode: 'AWG',
        langName: 'Spanish (Aruba)',
        langIso: 'es_AW',
    },
    {
        name: 'Aruba',
        officialName: 'Aruba',
        numeric: '533',
        alpha2: 'AW',
        alpha3: 'ABW',
        currencyName: 'Aruban Florin',
        currencyAlphabeticCode: 'AWG',
        langName: 'English (Aruba)',
        langIso: 'en_AW',
    },
    {
        name: 'Australia',
        officialName: 'Australia',
        numeric: '036',
        alpha2: 'AU',
        alpha3: 'AUS',
        currencyName: 'Australian Dollar',
        currencyAlphabeticCode: 'AUD',
        langName: 'English (Australia)',
        langIso: 'en_AU',
    },
    {
        name: 'Austria',
        officialName: 'Austria',
        numeric: '040',
        alpha2: 'AT',
        alpha3: 'AUT',
        currencyName: 'Euro',
        currencyAlphabeticCode: 'EUR',
        langName: 'German (Austria)',
        langIso: 'de_AT',
    },
    {
        name: 'Austria',
        officialName: 'Austria',
        numeric: '040',
        alpha2: 'AT',
        alpha3: 'AUT',
        currencyName: 'Euro',
        currencyAlphabeticCode: 'EUR',
        langName: 'Croatian (Austria)',
        langIso: 'hr_AT',
    },
    {
        name: 'Austria',
        officialName: 'Austria',
        numeric: '040',
        alpha2: 'AT',
        alpha3: 'AUT',
        currencyName: 'Euro',
        currencyAlphabeticCode: 'EUR',
        langName: 'Hungarian (Austria)',
        langIso: 'hu_AT',
    },
    {
        name: 'Austria',
        officialName: 'Austria',
        numeric: '040',
        alpha2: 'AT',
        alpha3: 'AUT',
        currencyName: 'Euro',
        currencyAlphabeticCode: 'EUR',
        langName: 'Slovenian (Austria)',
        langIso: 'sl_AT',
    },
    {
        name: 'Azerbaijan',
        officialName: 'Azerbaijan',
        numeric: '031',
        alpha2: 'AZ',
        alpha3: 'AZE',
        currencyName: 'Azerbaijan Manat',
        currencyAlphabeticCode: 'AZN',
        langName: 'Azerbaijani (Azerbaijan)',
        langIso: 'az_AZ',
    },
    {
        name: 'Azerbaijan',
        officialName: 'Azerbaijan',
        numeric: '031',
        alpha2: 'AZ',
        alpha3: 'AZE',
        currencyName: 'Azerbaijan Manat',
        currencyAlphabeticCode: 'AZN',
        langName: 'Russian (Azerbaijan)',
        langIso: 'ru_AZ',
    },
    {
        name: 'Azerbaijan',
        officialName: 'Azerbaijan',
        numeric: '031',
        alpha2: 'AZ',
        alpha3: 'AZE',
        currencyName: 'Azerbaijan Manat',
        currencyAlphabeticCode: 'AZN',
        langName: 'Armenian (Azerbaijan)',
        langIso: 'hy_AZ',
    },
    {
        name: 'Bahrain',
        officialName: 'Bahrain',
        numeric: '048',
        alpha2: 'BH',
        alpha3: 'BHR',
        currencyName: 'Bahraini Dinar',
        currencyAlphabeticCode: 'BHD',
        langName: 'Arabic (Bahrain)',
        langIso: 'ar_BH',
    },
    {
        name: 'Bahrain',
        officialName: 'Bahrain',
        numeric: '048',
        alpha2: 'BH',
        alpha3: 'BHR',
        currencyName: 'Bahraini Dinar',
        currencyAlphabeticCode: 'BHD',
        langName: 'English (Bahrain)',
        langIso: 'en_BH',
    },
    {
        name: 'Bahrain',
        officialName: 'Bahrain',
        numeric: '048',
        alpha2: 'BH',
        alpha3: 'BHR',
        currencyName: 'Bahraini Dinar',
        currencyAlphabeticCode: 'BHD',
        langName: 'Persian (Bahrain)',
        langIso: 'fa_BH',
    },
    {
        name: 'Bahrain',
        officialName: 'Bahrain',
        numeric: '048',
        alpha2: 'BH',
        alpha3: 'BHR',
        currencyName: 'Bahraini Dinar',
        currencyAlphabeticCode: 'BHD',
        langName: 'Urdu (Bahrain)',
        langIso: 'ur_BH',
    },
    {
        name: 'Bangladesh',
        officialName: 'Bangladesh',
        numeric: '050',
        alpha2: 'BD',
        alpha3: 'BGD',
        currencyName: 'Taka',
        currencyAlphabeticCode: 'BDT',
        langName: 'Bengali (Bangladesh)',
        langIso: 'bn_BD',
    },
    {
        name: 'Bangladesh',
        officialName: 'Bangladesh',
        numeric: '050',
        alpha2: 'BD',
        alpha3: 'BGD',
        currencyName: 'Taka',
        currencyAlphabeticCode: 'BDT',
        langName: 'English (Bangladesh)',
        langIso: 'en_BD',
    },
    {
        name: 'Barbados',
        officialName: 'Barbados',
        numeric: '052',
        alpha2: 'BB',
        alpha3: 'BRB',
        currencyName: 'Barbados Dollar',
        currencyAlphabeticCode: 'BBD',
        langName: 'English (Barbados)',
        langIso: 'en_BB',
    },
    {
        name: 'Belarus',
        officialName: 'Belarus',
        numeric: '112',
        alpha2: 'BY',
        alpha3: 'BLR',
        currencyName: 'Belarusian Ruble',
        currencyAlphabeticCode: 'BYN',
        langName: 'Belarusian (Belarus)',
        langIso: 'be_BY',
    },
    {
        name: 'Belarus',
        officialName: 'Belarus',
        numeric: '112',
        alpha2: 'BY',
        alpha3: 'BLR',
        currencyName: 'Belarusian Ruble',
        currencyAlphabeticCode: 'BYN',
        langName: 'Russian (Belarus)',
        langIso: 'ru_BY',
    },
    {
        name: 'Belgium',
        officialName: 'Belgium',
        numeric: '056',
        alpha2: 'BE',
        alpha3: 'BEL',
        currencyName: 'Euro',
        currencyAlphabeticCode: 'EUR',
        langName: 'Dutch (Belgium)',
        langIso: 'nl_BE',
    },
    {
        name: 'Belgium',
        officialName: 'Belgium',
        numeric: '056',
        alpha2: 'BE',
        alpha3: 'BEL',
        currencyName: 'Euro',
        currencyAlphabeticCode: 'EUR',
        langName: 'French (Belgium)',
        langIso: 'fr_BE',
    },
    {
        name: 'Belgium',
        officialName: 'Belgium',
        numeric: '056',
        alpha2: 'BE',
        alpha3: 'BEL',
        currencyName: 'Euro',
        currencyAlphabeticCode: 'EUR',
        langName: 'German (Belgium)',
        langIso: 'de_BE',
    },
    {
        name: 'Belize',
        officialName: 'Belize',
        numeric: '084',
        alpha2: 'BZ',
        alpha3: 'BLZ',
        currencyName: 'Belize Dollar',
        currencyAlphabeticCode: 'BZD',
        langName: 'English (Belize)',
        langIso: 'en_BZ',
    },
    {
        name: 'Belize',
        officialName: 'Belize',
        numeric: '084',
        alpha2: 'BZ',
        alpha3: 'BLZ',
        currencyName: 'Belize Dollar',
        currencyAlphabeticCode: 'BZD',
        langName: 'Spanish (Belize)',
        langIso: 'es_BZ',
    },
    {
        name: 'Benin',
        officialName: 'Benin',
        numeric: '204',
        alpha2: 'BJ',
        alpha3: 'BEN',
        currencyName: 'CFA Franc BCEAO',
        currencyAlphabeticCode: 'XOF',
        langName: 'French (Benin)',
        langIso: 'fr_BJ',
    },
    {
        name: 'Bermuda',
        officialName: 'Bermuda',
        numeric: '060',
        alpha2: 'BM',
        alpha3: 'BMU',
        currencyName: 'Bermudian Dollar',
        currencyAlphabeticCode: 'BMD',
        langName: 'English (Bermuda)',
        langIso: 'en_BM',
    },
    {
        name: 'Bermuda',
        officialName: 'Bermuda',
        numeric: '060',
        alpha2: 'BM',
        alpha3: 'BMU',
        currencyName: 'Bermudian Dollar',
        currencyAlphabeticCode: 'BMD',
        langName: 'Portuguese (Bermuda)',
        langIso: 'pt_BM',
    },
    {
        name: 'Bhutan',
        officialName: 'Bhutan',
        numeric: '064',
        alpha2: 'BT',
        alpha3: 'BTN',
        currencyName: 'Indian Rupee,Ngultrum',
        currencyAlphabeticCode: 'INR,BTN',
        langName: 'Dzongkha (Bhutan)',
        langIso: 'dz_BT',
    },
    {
        name: 'Bolivia',
        officialName: 'Bolivia (Plurinational State of)',
        numeric: '068',
        alpha2: 'BO',
        alpha3: 'BOL',
        currencyName: 'Boliviano',
        currencyAlphabeticCode: 'BOB',
        langName: 'Spanish (Bolivia)',
        langIso: 'es_BO',
    },
    {
        name: 'Bolivia',
        officialName: 'Bolivia (Plurinational State of)',
        numeric: '068',
        alpha2: 'BO',
        alpha3: 'BOL',
        currencyName: 'Boliviano',
        currencyAlphabeticCode: 'BOB',
        langName: 'Quechua (Bolivia)',
        langIso: 'qu_BO',
    },
    {
        name: 'Bolivia',
        officialName: 'Bolivia (Plurinational State of)',
        numeric: '068',
        alpha2: 'BO',
        alpha3: 'BOL',
        currencyName: 'Boliviano',
        currencyAlphabeticCode: 'BOB',
        langName: 'Aymara (Bolivia)',
        langIso: 'ay_BO',
    },
    {
        name: 'Caribbean Netherlands',
        officialName: 'Bonaire, Sint Eustatius and Saba',
        numeric: '535',
        alpha2: 'BQ',
        alpha3: 'BES',
        currencyName: 'US Dollar',
        currencyAlphabeticCode: 'USD',
        langName: 'Dutch (Caribbean Netherlands)',
        langIso: 'nl_BQ',
    },
    {
        name: 'Caribbean Netherlands',
        officialName: 'Bonaire, Sint Eustatius and Saba',
        numeric: '535',
        alpha2: 'BQ',
        alpha3: 'BES',
        currencyName: 'US Dollar',
        currencyAlphabeticCode: 'USD',
        langName: 'English (Caribbean Netherlands)',
        langIso: 'en_BQ',
    },
    {
        name: 'Bosnia',
        officialName: 'Bosnia and Herzegovina',
        numeric: '070',
        alpha2: 'BA',
        alpha3: 'BIH',
        currencyName: 'Convertible Mark',
        currencyAlphabeticCode: 'BAM',
        langName: 'Serbian (Bosnia and Herzegovina)',
        langIso: 'sr_BA',
    },
    {
        name: 'Botswana',
        officialName: 'Botswana',
        numeric: '072',
        alpha2: 'BW',
        alpha3: 'BWA',
        currencyName: 'Pula',
        currencyAlphabeticCode: 'BWP',
        langName: 'English (Botswana)',
        langIso: 'en_BW',
    },
    {
        name: 'Brazil',
        officialName: 'Brazil',
        numeric: '076',
        alpha2: 'BR',
        alpha3: 'BRA',
        currencyName: 'Brazilian Real',
        currencyAlphabeticCode: 'BRL',
        langName: 'Portuguese (Brazil)',
        langIso: 'pt_BR',
    },
    {
        name: 'Brazil',
        officialName: 'Brazil',
        numeric: '076',
        alpha2: 'BR',
        alpha3: 'BRA',
        currencyName: 'Brazilian Real',
        currencyAlphabeticCode: 'BRL',
        langName: 'Spanish (Brazil)',
        langIso: 'es_BR',
    },
    {
        name: 'Brazil',
        officialName: 'Brazil',
        numeric: '076',
        alpha2: 'BR',
        alpha3: 'BRA',
        currencyName: 'Brazilian Real',
        currencyAlphabeticCode: 'BRL',
        langName: 'English (Brazil)',
        langIso: 'en_BR',
    },
    {
        name: 'Brazil',
        officialName: 'Brazil',
        numeric: '076',
        alpha2: 'BR',
        alpha3: 'BRA',
        currencyName: 'Brazilian Real',
        currencyAlphabeticCode: 'BRL',
        langName: 'French (Brazil)',
        langIso: 'fr_BR',
    },
    {
        name: 'Brunei',
        officialName: 'Brunei Darussalam',
        numeric: '096',
        alpha2: 'BN',
        alpha3: 'BRN',
        currencyName: 'Brunei Dollar',
        currencyAlphabeticCode: 'BND',
        langName: 'Malay (Brunei)',
        langIso: 'ms_BN',
    },
    {
        name: 'Bulgaria',
        officialName: 'Bulgaria',
        numeric: '100',
        alpha2: 'BG',
        alpha3: 'BGR',
        currencyName: 'Bulgarian Lev',
        currencyAlphabeticCode: 'BGN',
        langName: 'Bulgarian (Bulgaria)',
        langIso: 'bg_BG',
    },
    {
        name: 'Burkina Faso',
        officialName: 'Burkina Faso',
        numeric: '854',
        alpha2: 'BF',
        alpha3: 'BFA',
        currencyName: 'CFA Franc BCEAO',
        currencyAlphabeticCode: 'XOF',
        langName: 'French (Burkina Faso)',
        langIso: 'fr_BF',
    },
    {
        name: 'Burundi',
        officialName: 'Burundi',
        numeric: '108',
        alpha2: 'BI',
        alpha3: 'BDI',
        currencyName: 'Burundi Franc',
        currencyAlphabeticCode: 'BIF',
        langName: 'French (Burundi)',
        langIso: 'fr_BI',
    },
    {
        name: 'Burundi',
        officialName: 'Burundi',
        numeric: '108',
        alpha2: 'BI',
        alpha3: 'BDI',
        currencyName: 'Burundi Franc',
        currencyAlphabeticCode: 'BIF',
        langName: 'Rundi (Burundi)',
        langIso: 'rn_BI',
    },
    {
        name: 'Cambodia',
        officialName: 'Cambodia',
        numeric: '116',
        alpha2: 'KH',
        alpha3: 'KHM',
        currencyName: 'Riel',
        currencyAlphabeticCode: 'KHR',
        langName: 'French (Cambodia)',
        langIso: 'fr_KH',
    },
    {
        name: 'Cambodia',
        officialName: 'Cambodia',
        numeric: '116',
        alpha2: 'KH',
        alpha3: 'KHM',
        currencyName: 'Riel',
        currencyAlphabeticCode: 'KHR',
        langName: 'English (Cambodia)',
        langIso: 'en_KH',
    },
    {
        name: 'Cameroon',
        officialName: 'Cameroon',
        numeric: '120',
        alpha2: 'CM',
        alpha3: 'CMR',
        currencyName: 'CFA Franc BEAC',
        currencyAlphabeticCode: 'XAF',
        langName: 'French (Cameroon)',
        langIso: 'fr_CM',
    },
    {
        name: 'Canada',
        officialName: 'Canada',
        numeric: '124',
        alpha2: 'CA',
        alpha3: 'CAN',
        currencyName: 'Canadian Dollar',
        currencyAlphabeticCode: 'CAD',
        langName: 'English (Canada)',
        langIso: 'en_CA',
    },
    {
        name: 'Canada',
        officialName: 'Canada',
        numeric: '124',
        alpha2: 'CA',
        alpha3: 'CAN',
        currencyName: 'Canadian Dollar',
        currencyAlphabeticCode: 'CAD',
        langName: 'French (Canada)',
        langIso: 'fr_CA',
    },
    {
        name: 'Canada',
        officialName: 'Canada',
        numeric: '124',
        alpha2: 'CA',
        alpha3: 'CAN',
        currencyName: 'Canadian Dollar',
        currencyAlphabeticCode: 'CAD',
        langName: 'Inuktitut (Canada)',
        langIso: 'iu_CA',
    },
    {
        name: 'Central African Republic',
        officialName: 'Central African Republic',
        numeric: '140',
        alpha2: 'CF',
        alpha3: 'CAF',
        currencyName: 'CFA Franc BEAC',
        currencyAlphabeticCode: 'XAF',
        langName: 'French (Central African Republic)',
        langIso: 'fr_CF',
    },
    {
        name: 'Central African Republic',
        officialName: 'Central African Republic',
        numeric: '140',
        alpha2: 'CF',
        alpha3: 'CAF',
        currencyName: 'CFA Franc BEAC',
        currencyAlphabeticCode: 'XAF',
        langName: 'Sango (Central African Republic)',
        langIso: 'sg_CF',
    },
    {
        name: 'Central African Republic',
        officialName: 'Central African Republic',
        numeric: '140',
        alpha2: 'CF',
        alpha3: 'CAF',
        currencyName: 'CFA Franc BEAC',
        currencyAlphabeticCode: 'XAF',
        langName: 'Lingala (Central African Republic)',
        langIso: 'ln_CF',
    },
    {
        name: 'Central African Republic',
        officialName: 'Central African Republic',
        numeric: '140',
        alpha2: 'CF',
        alpha3: 'CAF',
        currencyName: 'CFA Franc BEAC',
        currencyAlphabeticCode: 'XAF',
        langName: 'Kongo (Central African Republic)',
        langIso: 'kg_CF',
    },
    {
        name: 'Chad',
        officialName: 'Chad',
        numeric: '148',
        alpha2: 'TD',
        alpha3: 'TCD',
        currencyName: 'CFA Franc BEAC',
        currencyAlphabeticCode: 'XAF',
        langName: 'French (Chad)',
        langIso: 'fr_TD',
    },
    {
        name: 'Chile',
        officialName: 'Chile',
        numeric: '152',
        alpha2: 'CL',
        alpha3: 'CHL',
        currencyName: 'Chilean Peso',
        currencyAlphabeticCode: 'CLP',
        langName: 'Spanish (Chile)',
        langIso: 'es_CL',
    },
    {
        name: 'China',
        officialName: 'China',
        numeric: '156',
        alpha2: 'CN',
        alpha3: 'CHN',
        currencyName: 'Yuan Renminbi',
        currencyAlphabeticCode: 'CNY',
        langName: 'Yue Chinese (Cantonese) (China)',
        langIso: 'yue_CN',
    },
    {
        name: 'China',
        officialName: 'China',
        numeric: '156',
        alpha2: 'CN',
        alpha3: 'CHN',
        currencyName: 'Yuan Renminbi',
        currencyAlphabeticCode: 'CNY',
        langName: 'Uyghur, Uighur (China)',
        langIso: 'ug_CN',
    },
    {
        name: 'China',
        officialName: 'China',
        numeric: '156',
        alpha2: 'CN',
        alpha3: 'CHN',
        currencyName: 'Yuan Renminbi',
        currencyAlphabeticCode: 'CNY',
        langName: 'Zhuang, Chuang (China)',
        langIso: 'za_CN',
    },
    {
        name: 'Hong Kong',
        officialName: 'China, Hong Kong Special Administrative Region',
        numeric: '344',
        alpha2: 'HK',
        alpha3: 'HKG',
        currencyName: 'Hong Kong Dollar',
        currencyAlphabeticCode: 'HKD',
        langName: 'Chinese Traditional (Hong Kong)',
        langIso: 'zh_HK',
    },
    {
        name: 'Hong Kong',
        officialName: 'China, Hong Kong Special Administrative Region',
        numeric: '344',
        alpha2: 'HK',
        alpha3: 'HKG',
        currencyName: 'Hong Kong Dollar',
        currencyAlphabeticCode: 'HKD',
        langName: 'Yue Chinese (Cantonese) (Hong Kong)',
        langIso: 'yue_HK',
    },
    {
        name: 'Hong Kong',
        officialName: 'China, Hong Kong Special Administrative Region',
        numeric: '344',
        alpha2: 'HK',
        alpha3: 'HKG',
        currencyName: 'Hong Kong Dollar',
        currencyAlphabeticCode: 'HKD',
        langName: 'English (Hong Kong)',
        langIso: 'en_HK',
    },
    {
        name: 'Macau',
        officialName: 'China, Macao Special Administrative Region',
        numeric: '446',
        alpha2: 'MO',
        alpha3: 'MAC',
        currencyName: 'Pataca',
        currencyAlphabeticCode: 'MOP',
        langName: 'Portuguese (Macau)',
        langIso: 'pt_MO',
    },
    {
        name: 'Christmas Island',
        officialName: 'Christmas Island',
        numeric: '162',
        alpha2: 'CX',
        alpha3: 'CXR',
        currencyName: 'Australian Dollar',
        currencyAlphabeticCode: 'AUD',
        langName: 'English (Christmas Island)',
        langIso: 'en_CX',
    },
    {
        name: 'Cocos (Keeling) Islands',
        officialName: 'Cocos (Keeling) Islands',
        numeric: '166',
        alpha2: 'CC',
        alpha3: 'CCK',
        currencyName: 'Australian Dollar',
        currencyAlphabeticCode: 'AUD',
        langName: 'English (Cocos (Keeling) Islands)',
        langIso: 'en_CC',
    },
    {
        name: 'Colombia',
        officialName: 'Colombia',
        numeric: '170',
        alpha2: 'CO',
        alpha3: 'COL',
        currencyName: 'Colombian Peso',
        currencyAlphabeticCode: 'COP',
        langName: 'Spanish (Colombia)',
        langIso: 'es_CO',
    },
    {
        name: 'Comoros',
        officialName: 'Comoros',
        numeric: '174',
        alpha2: 'KM',
        alpha3: 'COM',
        currencyName: 'Comorian Franc',
        currencyAlphabeticCode: 'KMF',
        langName: 'Arabic (Comoros)',
        langIso: 'ar_KM',
    },
    {
        name: 'Comoros',
        officialName: 'Comoros',
        numeric: '174',
        alpha2: 'KM',
        alpha3: 'COM',
        currencyName: 'Comorian Franc',
        currencyAlphabeticCode: 'KMF',
        langName: 'French (Comoros)',
        langIso: 'fr_KM',
    },
    {
        name: 'Congo - Brazzaville',
        officialName: 'Congo',
        numeric: '178',
        alpha2: 'CG',
        alpha3: 'COG',
        currencyName: 'CFA Franc BEAC',
        currencyAlphabeticCode: 'XAF',
        langName: 'French (Congo - Brazzaville)',
        langIso: 'fr_CG',
    },
    {
        name: 'Congo - Brazzaville',
        officialName: 'Congo',
        numeric: '178',
        alpha2: 'CG',
        alpha3: 'COG',
        currencyName: 'CFA Franc BEAC',
        currencyAlphabeticCode: 'XAF',
        langName: 'Kongo (Congo - Brazzaville)',
        langIso: 'kg_CG',
    },
    {
        name: 'Congo - Brazzaville',
        officialName: 'Congo',
        numeric: '178',
        alpha2: 'CG',
        alpha3: 'COG',
        currencyName: 'CFA Franc BEAC',
        currencyAlphabeticCode: 'XAF',
        langName: 'Lingala (Congo - Brazzaville)',
        langIso: 'ln_CG',
    },
    {
        name: 'Costa Rica',
        officialName: 'Costa Rica',
        numeric: '188',
        alpha2: 'CR',
        alpha3: 'CRI',
        currencyName: 'Costa Rican Colon',
        currencyAlphabeticCode: 'CRC',
        langName: 'Spanish (Costa Rica)',
        langIso: 'es_CR',
    },
    {
        name: 'Costa Rica',
        officialName: 'Costa Rica',
        numeric: '188',
        alpha2: 'CR',
        alpha3: 'CRI',
        currencyName: 'Costa Rican Colon',
        currencyAlphabeticCode: 'CRC',
        langName: 'English (Costa Rica)',
        langIso: 'en_CR',
    },
    {
        name: 'Croatia',
        officialName: 'Croatia',
        numeric: '191',
        alpha2: 'HR',
        alpha3: 'HRV',
        currencyName: 'Kuna',
        currencyAlphabeticCode: 'HRK',
        langName: 'Croatian (Croatia)',
        langIso: 'hr_HR',
    },
    {
        name: 'Croatia',
        officialName: 'Croatia',
        numeric: '191',
        alpha2: 'HR',
        alpha3: 'HRV',
        currencyName: 'Kuna',
        currencyAlphabeticCode: 'HRK',
        langName: 'Serbian (Croatia)',
        langIso: 'sr_HR',
    },
    {
        name: 'Curaçao',
        officialName: 'Curaçao',
        numeric: '531',
        alpha2: 'CW',
        alpha3: 'CUW',
        currencyName: 'Netherlands Antillean Guilder',
        currencyAlphabeticCode: 'ANG',
        langName: 'Dutch (Curaçao)',
        langIso: 'nl_CW',
    },
    {
        name: 'Cyprus',
        officialName: 'Cyprus',
        numeric: '196',
        alpha2: 'CY',
        alpha3: 'CYP',
        currencyName: 'Euro',
        currencyAlphabeticCode: 'EUR',
        langName: 'Greek (Cyprus)',
        langIso: 'el_CY',
    },
    {
        name: 'Cyprus',
        officialName: 'Cyprus',
        numeric: '196',
        alpha2: 'CY',
        alpha3: 'CYP',
        currencyName: 'Euro',
        currencyAlphabeticCode: 'EUR',
        langName: 'English (Cyprus)',
        langIso: 'en_CY',
    },
    {
        name: 'Czechia',
        officialName: 'Czechia',
        numeric: '203',
        alpha2: 'CZ',
        alpha3: 'CZE',
        currencyName: 'Czech Koruna',
        currencyAlphabeticCode: 'CZK',
        langName: 'Czech (Czechia)',
        langIso: 'cs_CZ',
    },
    {
        name: 'Czechia',
        officialName: 'Czechia',
        numeric: '203',
        alpha2: 'CZ',
        alpha3: 'CZE',
        currencyName: 'Czech Koruna',
        currencyAlphabeticCode: 'CZK',
        langName: 'Slovak (Czechia)',
        langIso: 'sk_CZ',
    },
    {
        name: 'Côte d’Ivoire',
        officialName: "Côte d'Ivoire",
        numeric: '384',
        alpha2: 'CI',
        alpha3: 'CIV',
        currencyName: 'CFA Franc BCEAO',
        currencyAlphabeticCode: 'XOF',
        langName: 'French (Côte d’Ivoire)',
        langIso: 'fr_CI',
    },
    {
        name: 'Congo - Kinshasa',
        officialName: 'Democratic Republic of the Congo',
        numeric: '180',
        alpha2: 'CD',
        alpha3: 'COD',
        currencyName: 'Congolese Franc',
        currencyAlphabeticCode: 'CDF',
        langName: 'French (Congo - Kinshasa)',
        langIso: 'fr_CD',
    },
    {
        name: 'Congo - Kinshasa',
        officialName: 'Democratic Republic of the Congo',
        numeric: '180',
        alpha2: 'CD',
        alpha3: 'COD',
        currencyName: 'Congolese Franc',
        currencyAlphabeticCode: 'CDF',
        langName: 'Lingala (Congo - Kinshasa)',
        langIso: 'ln_CD',
    },
    {
        name: 'Congo - Kinshasa',
        officialName: 'Democratic Republic of the Congo',
        numeric: '180',
        alpha2: 'CD',
        alpha3: 'COD',
        currencyName: 'Congolese Franc',
        currencyAlphabeticCode: 'CDF',
        langName: 'Kongo (Congo - Kinshasa)',
        langIso: 'kg_CD',
    },
    {
        name: 'Congo - Kinshasa',
        officialName: 'Democratic Republic of the Congo',
        numeric: '180',
        alpha2: 'CD',
        alpha3: 'COD',
        currencyName: 'Congolese Franc',
        currencyAlphabeticCode: 'CDF',
        langName: 'Swahili (Congo - Kinshasa)',
        langIso: 'sw_CD',
    },
    {
        name: 'Denmark',
        officialName: 'Denmark',
        numeric: '208',
        alpha2: 'DK',
        alpha3: 'DNK',
        currencyName: 'Danish Krone',
        currencyAlphabeticCode: 'DKK',
        langName: 'Danish (Denmark)',
        langIso: 'da_DK',
    },
    {
        name: 'Denmark',
        officialName: 'Denmark',
        numeric: '208',
        alpha2: 'DK',
        alpha3: 'DNK',
        currencyName: 'Danish Krone',
        currencyAlphabeticCode: 'DKK',
        langName: 'English (Denmark)',
        langIso: 'en_DK',
    },
    {
        name: 'Djibouti',
        officialName: 'Djibouti',
        numeric: '262',
        alpha2: 'DJ',
        alpha3: 'DJI',
        currencyName: 'Djibouti Franc',
        currencyAlphabeticCode: 'DJF',
        langName: 'French (Djibouti)',
        langIso: 'fr_DJ',
    },
    {
        name: 'Djibouti',
        officialName: 'Djibouti',
        numeric: '262',
        alpha2: 'DJ',
        alpha3: 'DJI',
        currencyName: 'Djibouti Franc',
        currencyAlphabeticCode: 'DJF',
        langName: 'Arabic (Djibouti)',
        langIso: 'ar_DJ',
    },
    {
        name: 'Djibouti',
        officialName: 'Djibouti',
        numeric: '262',
        alpha2: 'DJ',
        alpha3: 'DJI',
        currencyName: 'Djibouti Franc',
        currencyAlphabeticCode: 'DJF',
        langName: 'Somali (Djibouti)',
        langIso: 'so_DJ',
    },
    {
        name: 'Djibouti',
        officialName: 'Djibouti',
        numeric: '262',
        alpha2: 'DJ',
        alpha3: 'DJI',
        currencyName: 'Djibouti Franc',
        currencyAlphabeticCode: 'DJF',
        langName: 'Afar (Djibouti)',
        langIso: 'aa_DJ',
    },
    {
        name: 'Dominican Republic',
        officialName: 'Dominican Republic',
        numeric: '214',
        alpha2: 'DO',
        alpha3: 'DOM',
        currencyName: 'Dominican Peso',
        currencyAlphabeticCode: 'DOP',
        langName: 'Spanish (Dominican Republic)',
        langIso: 'es_DO',
    },
    {
        name: 'Ecuador',
        officialName: 'Ecuador',
        numeric: '218',
        alpha2: 'EC',
        alpha3: 'ECU',
        currencyName: 'US Dollar',
        currencyAlphabeticCode: 'USD',
        langName: 'Spanish (Ecuador)',
        langIso: 'es_EC',
    },
    {
        name: 'Egypt',
        officialName: 'Egypt',
        numeric: '818',
        alpha2: 'EG',
        alpha3: 'EGY',
        currencyName: 'Egyptian Pound',
        currencyAlphabeticCode: 'EGP',
        langName: 'Arabic (Egypt)',
        langIso: 'ar_EG',
    },
    {
        name: 'Egypt',
        officialName: 'Egypt',
        numeric: '818',
        alpha2: 'EG',
        alpha3: 'EGY',
        currencyName: 'Egyptian Pound',
        currencyAlphabeticCode: 'EGP',
        langName: 'English (Egypt)',
        langIso: 'en_EG',
    },
    {
        name: 'Egypt',
        officialName: 'Egypt',
        numeric: '818',
        alpha2: 'EG',
        alpha3: 'EGY',
        currencyName: 'Egyptian Pound',
        currencyAlphabeticCode: 'EGP',
        langName: 'French (Egypt)',
        langIso: 'fr_EG',
    },
    {
        name: 'El Salvador',
        officialName: 'El Salvador',
        numeric: '222',
        alpha2: 'SV',
        alpha3: 'SLV',
        currencyName: 'El Salvador Colon,US Dollar',
        currencyAlphabeticCode: 'SVC,USD',
        langName: 'Spanish (El Salvador)',
        langIso: 'es_SV',
    },
    {
        name: 'Equatorial Guinea',
        officialName: 'Equatorial Guinea',
        numeric: '226',
        alpha2: 'GQ',
        alpha3: 'GNQ',
        currencyName: 'CFA Franc BEAC',
        currencyAlphabeticCode: 'XAF',
        langName: 'Spanish (Equatorial Guinea)',
        langIso: 'es_GQ',
    },
    {
        name: 'Equatorial Guinea',
        officialName: 'Equatorial Guinea',
        numeric: '226',
        alpha2: 'GQ',
        alpha3: 'GNQ',
        currencyName: 'CFA Franc BEAC',
        currencyAlphabeticCode: 'XAF',
        langName: 'French (Equatorial Guinea)',
        langIso: 'fr_GQ',
    },
    {
        name: 'Eritrea',
        officialName: 'Eritrea',
        numeric: '232',
        alpha2: 'ER',
        alpha3: 'ERI',
        currencyName: 'Nakfa',
        currencyAlphabeticCode: 'ERN',
        langName: 'Arabic (Eritrea)',
        langIso: 'ar_ER',
    },
    {
        name: 'Eritrea',
        officialName: 'Eritrea',
        numeric: '232',
        alpha2: 'ER',
        alpha3: 'ERI',
        currencyName: 'Nakfa',
        currencyAlphabeticCode: 'ERN',
        langName: 'Tigrinya (Eritrea)',
        langIso: 'ti_ER',
    },
    {
        name: 'Estonia',
        officialName: 'Estonia',
        numeric: '233',
        alpha2: 'EE',
        alpha3: 'EST',
        currencyName: 'Euro',
        currencyAlphabeticCode: 'EUR',
        langName: 'Estonian (Estonia)',
        langIso: 'et_EE',
    },
    {
        name: 'Estonia',
        officialName: 'Estonia',
        numeric: '233',
        alpha2: 'EE',
        alpha3: 'EST',
        currencyName: 'Euro',
        currencyAlphabeticCode: 'EUR',
        langName: 'Russian (Estonia)',
        langIso: 'ru_EE',
    },
    {
        name: 'Ethiopia',
        officialName: 'Ethiopia',
        numeric: '231',
        alpha2: 'ET',
        alpha3: 'ETH',
        currencyName: 'Ethiopian Birr',
        currencyAlphabeticCode: 'ETB',
        langName: 'Amharic (Ethiopia)',
        langIso: 'am_ET',
    },
    {
        name: 'Ethiopia',
        officialName: 'Ethiopia',
        numeric: '231',
        alpha2: 'ET',
        alpha3: 'ETH',
        currencyName: 'Ethiopian Birr',
        currencyAlphabeticCode: 'ETB',
        langName: 'Oromo (Ethiopia)',
        langIso: 'om_ET',
    },
    {
        name: 'Ethiopia',
        officialName: 'Ethiopia',
        numeric: '231',
        alpha2: 'ET',
        alpha3: 'ETH',
        currencyName: 'Ethiopian Birr',
        currencyAlphabeticCode: 'ETB',
        langName: 'Tigrinya (Ethiopia)',
        langIso: 'ti_ET',
    },
    {
        name: 'Ethiopia',
        officialName: 'Ethiopia',
        numeric: '231',
        alpha2: 'ET',
        alpha3: 'ETH',
        currencyName: 'Ethiopian Birr',
        currencyAlphabeticCode: 'ETB',
        langName: 'Somali (Ethiopia)',
        langIso: 'so_ET',
    },
    {
        name: 'Fiji',
        officialName: 'Fiji',
        numeric: '242',
        alpha2: 'FJ',
        alpha3: 'FJI',
        currencyName: 'Fiji Dollar',
        currencyAlphabeticCode: 'FJD',
        langName: 'Fijian (Fiji)',
        langIso: 'fj_FJ',
    },
    {
        name: 'Finland',
        officialName: 'Finland',
        numeric: '246',
        alpha2: 'FI',
        alpha3: 'FIN',
        currencyName: 'Euro',
        currencyAlphabeticCode: 'EUR',
        langName: 'Finnish (Finland)',
        langIso: 'fi_FI',
    },
    {
        name: 'Finland',
        officialName: 'Finland',
        numeric: '246',
        alpha2: 'FI',
        alpha3: 'FIN',
        currencyName: 'Euro',
        currencyAlphabeticCode: 'EUR',
        langName: 'Swedish (Finland)',
        langIso: 'sv_FI',
    },
    {
        name: 'France',
        officialName: 'France',
        numeric: '250',
        alpha2: 'FR',
        alpha3: 'FRA',
        currencyName: 'Euro',
        currencyAlphabeticCode: 'EUR',
        langName: 'Breton (France)',
        langIso: 'br_FR',
    },
    {
        name: 'France',
        officialName: 'France',
        numeric: '250',
        alpha2: 'FR',
        alpha3: 'FRA',
        currencyName: 'Euro',
        currencyAlphabeticCode: 'EUR',
        langName: 'Corsican (France)',
        langIso: 'co_FR',
    },
    {
        name: 'France',
        officialName: 'France',
        numeric: '250',
        alpha2: 'FR',
        alpha3: 'FRA',
        currencyName: 'Euro',
        currencyAlphabeticCode: 'EUR',
        langName: 'Catalan (France)',
        langIso: 'ca_FR',
    },
    {
        name: 'France',
        officialName: 'France',
        numeric: '250',
        alpha2: 'FR',
        alpha3: 'FRA',
        currencyName: 'Euro',
        currencyAlphabeticCode: 'EUR',
        langName: 'Basque (France)',
        langIso: 'eu_FR',
    },
    {
        name: 'France',
        officialName: 'France',
        numeric: '250',
        alpha2: 'FR',
        alpha3: 'FRA',
        currencyName: 'Euro',
        currencyAlphabeticCode: 'EUR',
        langName: 'Occitan (France)',
        langIso: 'oc_FR',
    },
    {
        name: 'French Guiana',
        officialName: 'French Guiana',
        numeric: '254',
        alpha2: 'GF',
        alpha3: 'GUF',
        currencyName: 'Euro',
        currencyAlphabeticCode: 'EUR',
        langName: 'French (French Guiana)',
        langIso: 'fr_GF',
    },
    {
        name: 'French Polynesia',
        officialName: 'French Polynesia',
        numeric: '258',
        alpha2: 'PF',
        alpha3: 'PYF',
        currencyName: 'CFP Franc',
        currencyAlphabeticCode: 'XPF',
        langName: 'Tahitian (French Polynesia)',
        langIso: 'ty_PF',
    },
    {
        name: 'French Southern Territories',
        officialName: 'French Southern Territories',
        numeric: '260',
        alpha2: 'TF',
        alpha3: 'ATF',
        currencyName: 'Euro',
        currencyAlphabeticCode: 'EUR',
        langName: 'French (French Southern Territories)',
        langIso: 'fr_TF',
    },
    {
        name: 'Gabon',
        officialName: 'Gabon',
        numeric: '266',
        alpha2: 'GA',
        alpha3: 'GAB',
        currencyName: 'CFA Franc BEAC',
        currencyAlphabeticCode: 'XAF',
        langName: 'French (Gabon)',
        langIso: 'fr_GA',
    },
    {
        name: 'Gambia',
        officialName: 'Gambia',
        numeric: '270',
        alpha2: 'GM',
        alpha3: 'GMB',
        currencyName: 'Dalasi',
        currencyAlphabeticCode: 'GMD',
        langName: 'Wolof (Gambia)',
        langIso: 'wo_GM',
    },
    {
        name: 'Gambia',
        officialName: 'Gambia',
        numeric: '270',
        alpha2: 'GM',
        alpha3: 'GMB',
        currencyName: 'Dalasi',
        currencyAlphabeticCode: 'GMD',
        langName: 'Fulah (Gambia)',
        langIso: 'ff_GM',
    },
    {
        name: 'Georgia',
        officialName: 'Georgia',
        numeric: '268',
        alpha2: 'GE',
        alpha3: 'GEO',
        currencyName: 'Lari',
        currencyAlphabeticCode: 'GEL',
        langName: 'Russian (Georgia)',
        langIso: 'ru_GE',
    },
    {
        name: 'Georgia',
        officialName: 'Georgia',
        numeric: '268',
        alpha2: 'GE',
        alpha3: 'GEO',
        currencyName: 'Lari',
        currencyAlphabeticCode: 'GEL',
        langName: 'Armenian (Georgia)',
        langIso: 'hy_GE',
    },
    {
        name: 'Georgia',
        officialName: 'Georgia',
        numeric: '268',
        alpha2: 'GE',
        alpha3: 'GEO',
        currencyName: 'Lari',
        currencyAlphabeticCode: 'GEL',
        langName: 'Azerbaijani (Georgia)',
        langIso: 'az_GE',
    },
    {
        name: 'Ghana',
        officialName: 'Ghana',
        numeric: '288',
        alpha2: 'GH',
        alpha3: 'GHA',
        currencyName: 'Ghana Cedi',
        currencyAlphabeticCode: 'GHS',
        langName: 'Akan (Ghana)',
        langIso: 'ak_GH',
    },
    {
        name: 'Ghana',
        officialName: 'Ghana',
        numeric: '288',
        alpha2: 'GH',
        alpha3: 'GHA',
        currencyName: 'Ghana Cedi',
        currencyAlphabeticCode: 'GHS',
        langName: 'Ewe (Ghana)',
        langIso: 'ee_GH',
    },
    {
        name: 'Ghana',
        officialName: 'Ghana',
        numeric: '288',
        alpha2: 'GH',
        alpha3: 'GHA',
        currencyName: 'Ghana Cedi',
        currencyAlphabeticCode: 'GHS',
        langName: 'Twi (Ghana)',
        langIso: 'tw_GH',
    },
    {
        name: 'Gibraltar',
        officialName: 'Gibraltar',
        numeric: '292',
        alpha2: 'GI',
        alpha3: 'GIB',
        currencyName: 'Gibraltar Pound',
        currencyAlphabeticCode: 'GIP',
        langName: 'Spanish (Gibraltar)',
        langIso: 'es_GI',
    },
    {
        name: 'Gibraltar',
        officialName: 'Gibraltar',
        numeric: '292',
        alpha2: 'GI',
        alpha3: 'GIB',
        currencyName: 'Gibraltar Pound',
        currencyAlphabeticCode: 'GIP',
        langName: 'Italian (Gibraltar)',
        langIso: 'it_GI',
    },
    {
        name: 'Gibraltar',
        officialName: 'Gibraltar',
        numeric: '292',
        alpha2: 'GI',
        alpha3: 'GIB',
        currencyName: 'Gibraltar Pound',
        currencyAlphabeticCode: 'GIP',
        langName: 'Portuguese (Gibraltar)',
        langIso: 'pt_GI',
    },
    {
        name: 'Greece',
        officialName: 'Greece',
        numeric: '300',
        alpha2: 'GR',
        alpha3: 'GRC',
        currencyName: 'Euro',
        currencyAlphabeticCode: 'EUR',
        langName: 'Greek (Greece)',
        langIso: 'el_GR',
    },
    {
        name: 'Greece',
        officialName: 'Greece',
        numeric: '300',
        alpha2: 'GR',
        alpha3: 'GRC',
        currencyName: 'Euro',
        currencyAlphabeticCode: 'EUR',
        langName: 'English (Greece)',
        langIso: 'en_GR',
    },
    {
        name: 'Greece',
        officialName: 'Greece',
        numeric: '300',
        alpha2: 'GR',
        alpha3: 'GRC',
        currencyName: 'Euro',
        currencyAlphabeticCode: 'EUR',
        langName: 'French (Greece)',
        langIso: 'fr_GR',
    },
    {
        name: 'Greenland',
        officialName: 'Greenland',
        numeric: '304',
        alpha2: 'GL',
        alpha3: 'GRL',
        currencyName: 'Danish Krone',
        currencyAlphabeticCode: 'DKK',
        langName: 'Kalaallisut (Greenland)',
        langIso: 'kl_GL',
    },
    {
        name: 'Greenland',
        officialName: 'Greenland',
        numeric: '304',
        alpha2: 'GL',
        alpha3: 'GRL',
        currencyName: 'Danish Krone',
        currencyAlphabeticCode: 'DKK',
        langName: 'English (Greenland)',
        langIso: 'en_GL',
    },
    {
        name: 'Guadeloupe',
        officialName: 'Guadeloupe',
        numeric: '312',
        alpha2: 'GP',
        alpha3: 'GLP',
        currencyName: 'Euro',
        currencyAlphabeticCode: 'EUR',
        langName: 'French (Guadeloupe)',
        langIso: 'fr_GP',
    },
    {
        name: 'Guam',
        officialName: 'Guam',
        numeric: '316',
        alpha2: 'GU',
        alpha3: 'GUM',
        currencyName: 'US Dollar',
        currencyAlphabeticCode: 'USD',
        langName: 'English (Guam)',
        langIso: 'en_GU',
    },
    {
        name: 'Guatemala',
        officialName: 'Guatemala',
        numeric: '320',
        alpha2: 'GT',
        alpha3: 'GTM',
        currencyName: 'Quetzal',
        currencyAlphabeticCode: 'GTQ',
        langName: 'Spanish (Guatemala)',
        langIso: 'es_GT',
    },
    {
        name: 'Guernsey',
        officialName: 'Guernsey',
        numeric: '831',
        alpha2: 'GG',
        alpha3: 'GGY',
        currencyName: 'Pound Sterling',
        currencyAlphabeticCode: 'GBP',
        langName: 'English (Guernsey)',
        langIso: 'en_GG',
    },
    {
        name: 'Guinea',
        officialName: 'Guinea',
        numeric: '324',
        alpha2: 'GN',
        alpha3: 'GIN',
        currencyName: 'Guinean Franc',
        currencyAlphabeticCode: 'GNF',
        langName: 'French (Guinea)',
        langIso: 'fr_GN',
    },
    {
        name: 'Guinea-Bissau',
        officialName: 'Guinea-Bissau',
        numeric: '624',
        alpha2: 'GW',
        alpha3: 'GNB',
        currencyName: 'CFA Franc BCEAO',
        currencyAlphabeticCode: 'XOF',
        langName: 'Portuguese (Guinea - Bissau)',
        langIso: 'pt_GW',
    },
    {
        name: 'Guyana',
        officialName: 'Guyana',
        numeric: '328',
        alpha2: 'GY',
        alpha3: 'GUY',
        currencyName: 'Guyana Dollar',
        currencyAlphabeticCode: 'GYD',
        langName: 'English (Guyana)',
        langIso: 'en_GY',
    },
    {
        name: 'Vatican City',
        officialName: 'Holy See',
        numeric: '336',
        alpha2: 'VA',
        alpha3: 'VAT',
        currencyName: 'Euro',
        currencyAlphabeticCode: 'EUR',
        langName: 'Italian (Vatican City)',
        langIso: 'it_VA',
    },
    {
        name: 'Vatican City',
        officialName: 'Holy See',
        numeric: '336',
        alpha2: 'VA',
        alpha3: 'VAT',
        currencyName: 'Euro',
        currencyAlphabeticCode: 'EUR',
        langName: 'French (Vatican City)',
        langIso: 'fr_VA',
    },
    {
        name: 'Honduras',
        officialName: 'Honduras',
        numeric: '340',
        alpha2: 'HN',
        alpha3: 'HND',
        currencyName: 'Lempira',
        currencyAlphabeticCode: 'HNL',
        langName: 'Spanish (Honduras)',
        langIso: 'es_HN',
    },
    {
        name: 'Hungary',
        officialName: 'Hungary',
        numeric: '348',
        alpha2: 'HU',
        alpha3: 'HUN',
        currencyName: 'Forint',
        currencyAlphabeticCode: 'HUF',
        langName: 'Hungarian (Hungary)',
        langIso: 'hu_HU',
    },
    {
        name: 'Iceland',
        officialName: 'Iceland',
        numeric: '352',
        alpha2: 'IS',
        alpha3: 'ISL',
        currencyName: 'Iceland Krona',
        currencyAlphabeticCode: 'ISK',
        langName: 'Icelandic (Iceland)',
        langIso: 'is_IS',
    },
    {
        name: 'Iceland',
        officialName: 'Iceland',
        numeric: '352',
        alpha2: 'IS',
        alpha3: 'ISL',
        currencyName: 'Iceland Krona',
        currencyAlphabeticCode: 'ISK',
        langName: 'English (Iceland)',
        langIso: 'en_IS',
    },
    {
        name: 'Iceland',
        officialName: 'Iceland',
        numeric: '352',
        alpha2: 'IS',
        alpha3: 'ISL',
        currencyName: 'Iceland Krona',
        currencyAlphabeticCode: 'ISK',
        langName: 'German (Iceland)',
        langIso: 'de_IS',
    },
    {
        name: 'Iceland',
        officialName: 'Iceland',
        numeric: '352',
        alpha2: 'IS',
        alpha3: 'ISL',
        currencyName: 'Iceland Krona',
        currencyAlphabeticCode: 'ISK',
        langName: 'Danish (Iceland)',
        langIso: 'da_IS',
    },
    {
        name: 'Iceland',
        officialName: 'Iceland',
        numeric: '352',
        alpha2: 'IS',
        alpha3: 'ISL',
        currencyName: 'Iceland Krona',
        currencyAlphabeticCode: 'ISK',
        langName: 'Swedish (Iceland)',
        langIso: 'sv_IS',
    },
    {
        name: 'Iceland',
        officialName: 'Iceland',
        numeric: '352',
        alpha2: 'IS',
        alpha3: 'ISL',
        currencyName: 'Iceland Krona',
        currencyAlphabeticCode: 'ISK',
        langName: 'Norwegian (Iceland)',
        langIso: 'no_IS',
    },
    {
        name: 'India',
        officialName: 'India',
        numeric: '356',
        alpha2: 'IN',
        alpha3: 'IND',
        currencyName: 'Indian Rupee',
        currencyAlphabeticCode: 'INR',
        langName: 'English (India)',
        langIso: 'en_IN',
    },
    {
        name: 'India',
        officialName: 'India',
        numeric: '356',
        alpha2: 'IN',
        alpha3: 'IND',
        currencyName: 'Indian Rupee',
        currencyAlphabeticCode: 'INR',
        langName: 'Hindi (India)',
        langIso: 'hi_IN',
    },
    {
        name: 'India',
        officialName: 'India',
        numeric: '356',
        alpha2: 'IN',
        alpha3: 'IND',
        currencyName: 'Indian Rupee',
        currencyAlphabeticCode: 'INR',
        langName: 'Bengali (India)',
        langIso: 'bn_IN',
    },
    {
        name: 'India',
        officialName: 'India',
        numeric: '356',
        alpha2: 'IN',
        alpha3: 'IND',
        currencyName: 'Indian Rupee',
        currencyAlphabeticCode: 'INR',
        langName: 'Telugu (India)',
        langIso: 'te_IN',
    },
    {
        name: 'India',
        officialName: 'India',
        numeric: '356',
        alpha2: 'IN',
        alpha3: 'IND',
        currencyName: 'Indian Rupee',
        currencyAlphabeticCode: 'INR',
        langName: 'Marathi (India)',
        langIso: 'mr_IN',
    },
    {
        name: 'India',
        officialName: 'India',
        numeric: '356',
        alpha2: 'IN',
        alpha3: 'IND',
        currencyName: 'Indian Rupee',
        currencyAlphabeticCode: 'INR',
        langName: 'Tamil (India)',
        langIso: 'ta_IN',
    },
    {
        name: 'India',
        officialName: 'India',
        numeric: '356',
        alpha2: 'IN',
        alpha3: 'IND',
        currencyName: 'Indian Rupee',
        currencyAlphabeticCode: 'INR',
        langName: 'Urdu (India)',
        langIso: 'ur_IN',
    },
    {
        name: 'India',
        officialName: 'India',
        numeric: '356',
        alpha2: 'IN',
        alpha3: 'IND',
        currencyName: 'Indian Rupee',
        currencyAlphabeticCode: 'INR',
        langName: 'Kannada (India)',
        langIso: 'kn_IN',
    },
    {
        name: 'India',
        officialName: 'India',
        numeric: '356',
        alpha2: 'IN',
        alpha3: 'IND',
        currencyName: 'Indian Rupee',
        currencyAlphabeticCode: 'INR',
        langName: 'Malayalam (India)',
        langIso: 'ml_IN',
    },
    {
        name: 'India',
        officialName: 'India',
        numeric: '356',
        alpha2: 'IN',
        alpha3: 'IND',
        currencyName: 'Indian Rupee',
        currencyAlphabeticCode: 'INR',
        langName: 'Odia (India)',
        langIso: 'or_IN',
    },
    {
        name: 'India',
        officialName: 'India',
        numeric: '356',
        alpha2: 'IN',
        alpha3: 'IND',
        currencyName: 'Indian Rupee',
        currencyAlphabeticCode: 'INR',
        langName: 'Punjabi (India)',
        langIso: 'pa_IN',
    },
    {
        name: 'India',
        officialName: 'India',
        numeric: '356',
        alpha2: 'IN',
        alpha3: 'IND',
        currencyName: 'Indian Rupee',
        currencyAlphabeticCode: 'INR',
        langName: 'Assamese (India)',
        langIso: 'as_IN',
    },
    {
        name: 'India',
        officialName: 'India',
        numeric: '356',
        alpha2: 'IN',
        alpha3: 'IND',
        currencyName: 'Indian Rupee',
        currencyAlphabeticCode: 'INR',
        langName: 'Bihari (India)',
        langIso: 'bh_IN',
    },
    {
        name: 'India',
        officialName: 'India',
        numeric: '356',
        alpha2: 'IN',
        alpha3: 'IND',
        currencyName: 'Indian Rupee',
        currencyAlphabeticCode: 'INR',
        langName: 'Kashmiri (India)',
        langIso: 'ks_IN',
    },
    {
        name: 'India',
        officialName: 'India',
        numeric: '356',
        alpha2: 'IN',
        alpha3: 'IND',
        currencyName: 'Indian Rupee',
        currencyAlphabeticCode: 'INR',
        langName: 'Nepali (India)',
        langIso: 'ne_IN',
    },
    {
        name: 'India',
        officialName: 'India',
        numeric: '356',
        alpha2: 'IN',
        alpha3: 'IND',
        currencyName: 'Indian Rupee',
        currencyAlphabeticCode: 'INR',
        langName: 'Sindhi (India)',
        langIso: 'sd_IN',
    },
    {
        name: 'India',
        officialName: 'India',
        numeric: '356',
        alpha2: 'IN',
        alpha3: 'IND',
        currencyName: 'Indian Rupee',
        currencyAlphabeticCode: 'INR',
        langName: 'Konkani (India)',
        langIso: 'kok_IN',
    },
    {
        name: 'India',
        officialName: 'India',
        numeric: '356',
        alpha2: 'IN',
        alpha3: 'IND',
        currencyName: 'Indian Rupee',
        currencyAlphabeticCode: 'INR',
        langName: 'Sanskrit (India)',
        langIso: 'sa_IN',
    },
    {
        name: 'India',
        officialName: 'India',
        numeric: '356',
        alpha2: 'IN',
        alpha3: 'IND',
        currencyName: 'Indian Rupee',
        currencyAlphabeticCode: 'INR',
        langName: 'French (India)',
        langIso: 'fr_IN',
    },
    {
        name: 'Indonesia',
        officialName: 'Indonesia',
        numeric: '360',
        alpha2: 'ID',
        alpha3: 'IDN',
        currencyName: 'Rupiah',
        currencyAlphabeticCode: 'IDR',
        langName: 'Indonesian (Indonesia)',
        langIso: 'id_ID',
    },
    {
        name: 'Indonesia',
        officialName: 'Indonesia',
        numeric: '360',
        alpha2: 'ID',
        alpha3: 'IDN',
        currencyName: 'Rupiah',
        currencyAlphabeticCode: 'IDR',
        langName: 'English (Indonesia)',
        langIso: 'en_ID',
    },
    {
        name: 'Indonesia',
        officialName: 'Indonesia',
        numeric: '360',
        alpha2: 'ID',
        alpha3: 'IDN',
        currencyName: 'Rupiah',
        currencyAlphabeticCode: 'IDR',
        langName: 'Dutch (Indonesia)',
        langIso: 'nl_ID',
    },
    {
        name: 'Indonesia',
        officialName: 'Indonesia',
        numeric: '360',
        alpha2: 'ID',
        alpha3: 'IDN',
        currencyName: 'Rupiah',
        currencyAlphabeticCode: 'IDR',
        langName: 'Javanese (Indonesia)',
        langIso: 'jv_ID',
    },
    {
        name: 'Iran',
        officialName: 'Iran (Islamic Republic of)',
        numeric: '364',
        alpha2: 'IR',
        alpha3: 'IRN',
        currencyName: 'Iranian Rial',
        currencyAlphabeticCode: 'IRR',
        langName: 'Persian (Iran)',
        langIso: 'fa_IR',
    },
    {
        name: 'Iraq',
        officialName: 'Iraq',
        numeric: '368',
        alpha2: 'IQ',
        alpha3: 'IRQ',
        currencyName: 'Iraqi Dinar',
        currencyAlphabeticCode: 'IQD',
        langName: 'Arabic (Iraq)',
        langIso: 'ar_IQ',
    },
    {
        name: 'Iraq',
        officialName: 'Iraq',
        numeric: '368',
        alpha2: 'IQ',
        alpha3: 'IRQ',
        currencyName: 'Iraqi Dinar',
        currencyAlphabeticCode: 'IQD',
        langName: 'Armenian (Iraq)',
        langIso: 'hy_IQ',
    },
    {
        name: 'Ireland',
        officialName: 'Ireland',
        numeric: '372',
        alpha2: 'IE',
        alpha3: 'IRL',
        currencyName: 'Euro',
        currencyAlphabeticCode: 'EUR',
        langName: 'English (Ireland)',
        langIso: 'en_IE',
    },
    {
        name: 'Ireland',
        officialName: 'Ireland',
        numeric: '372',
        alpha2: 'IE',
        alpha3: 'IRL',
        currencyName: 'Euro',
        currencyAlphabeticCode: 'EUR',
        langName: 'Irish (Ireland)',
        langIso: 'ga_IE',
    },
    {
        name: 'Isle of Man',
        officialName: 'Isle of Man',
        numeric: '833',
        alpha2: 'IM',
        alpha3: 'IMN',
        currencyName: 'Pound Sterling',
        currencyAlphabeticCode: 'GBP',
        langName: 'English (Isle of Man)',
        langIso: 'en_IM',
    },
    {
        name: 'Isle of Man',
        officialName: 'Isle of Man',
        numeric: '833',
        alpha2: 'IM',
        alpha3: 'IMN',
        currencyName: 'Pound Sterling',
        currencyAlphabeticCode: 'GBP',
        langName: 'Manx (Isle of Man)',
        langIso: 'gv_IM',
    },
    {
        name: 'Israel',
        officialName: 'Israel',
        numeric: '376',
        alpha2: 'IL',
        alpha3: 'ISR',
        currencyName: 'New Israeli Sheqel',
        currencyAlphabeticCode: 'ILS',
        langName: 'Hebrew (Israel)',
        langIso: 'he_IL',
    },
    {
        name: 'Israel',
        officialName: 'Israel',
        numeric: '376',
        alpha2: 'IL',
        alpha3: 'ISR',
        currencyName: 'New Israeli Sheqel',
        currencyAlphabeticCode: 'ILS',
        langName: 'English (Israel)',
        langIso: 'en_IL',
    },
    {
        name: 'Italy',
        officialName: 'Italy',
        numeric: '380',
        alpha2: 'IT',
        alpha3: 'ITA',
        currencyName: 'Euro',
        currencyAlphabeticCode: 'EUR',
        langName: 'Italian (Italy)',
        langIso: 'it_IT',
    },
    {
        name: 'Italy',
        officialName: 'Italy',
        numeric: '380',
        alpha2: 'IT',
        alpha3: 'ITA',
        currencyName: 'Euro',
        currencyAlphabeticCode: 'EUR',
        langName: 'Catalan (Italy)',
        langIso: 'ca_IT',
    },
    {
        name: 'Italy',
        officialName: 'Italy',
        numeric: '380',
        alpha2: 'IT',
        alpha3: 'ITA',
        currencyName: 'Euro',
        currencyAlphabeticCode: 'EUR',
        langName: 'Corsican (Italy)',
        langIso: 'co_IT',
    },
    {
        name: 'Italy',
        officialName: 'Italy',
        numeric: '380',
        alpha2: 'IT',
        alpha3: 'ITA',
        currencyName: 'Euro',
        currencyAlphabeticCode: 'EUR',
        langName: 'Slovenian (Italy)',
        langIso: 'sl_IT',
    },
    {
        name: 'Jamaica',
        officialName: 'Jamaica',
        numeric: '388',
        alpha2: 'JM',
        alpha3: 'JAM',
        currencyName: 'Jamaican Dollar',
        currencyAlphabeticCode: 'JMD',
        langName: 'English (Jamaica)',
        langIso: 'en_JM',
    },
    {
        name: 'Japan',
        officialName: 'Japan',
        numeric: '392',
        alpha2: 'JP',
        alpha3: 'JPN',
        currencyName: 'Yen',
        currencyAlphabeticCode: 'JPY',
        langName: 'Japanese (Japan)',
        langIso: 'ja_JP',
    },
    {
        name: 'Jersey',
        officialName: 'Jersey',
        numeric: '832',
        alpha2: 'JE',
        alpha3: 'JEY',
        currencyName: 'Pound Sterling',
        currencyAlphabeticCode: 'GBP',
        langName: 'English (Jersey)',
        langIso: 'en_JE',
    },
    {
        name: 'Jersey',
        officialName: 'Jersey',
        numeric: '832',
        alpha2: 'JE',
        alpha3: 'JEY',
        currencyName: 'Pound Sterling',
        currencyAlphabeticCode: 'GBP',
        langName: 'French (Jersey)',
        langIso: 'fr_JE',
    },
    {
        name: 'Jordan',
        officialName: 'Jordan',
        numeric: '400',
        alpha2: 'JO',
        alpha3: 'JOR',
        currencyName: 'Jordanian Dinar',
        currencyAlphabeticCode: 'JOD',
        langName: 'Arabic (Jordan)',
        langIso: 'ar_JO',
    },
    {
        name: 'Jordan',
        officialName: 'Jordan',
        numeric: '400',
        alpha2: 'JO',
        alpha3: 'JOR',
        currencyName: 'Jordanian Dinar',
        currencyAlphabeticCode: 'JOD',
        langName: 'English (Jordan)',
        langIso: 'en_JO',
    },
    {
        name: 'Kazakhstan',
        officialName: 'Kazakhstan',
        numeric: '398',
        alpha2: 'KZ',
        alpha3: 'KAZ',
        currencyName: 'Tenge',
        currencyAlphabeticCode: 'KZT',
        langName: 'Kazakh (Kazakhstan)',
        langIso: 'kk_KZ',
    },
    {
        name: 'Kazakhstan',
        officialName: 'Kazakhstan',
        numeric: '398',
        alpha2: 'KZ',
        alpha3: 'KAZ',
        currencyName: 'Tenge',
        currencyAlphabeticCode: 'KZT',
        langName: 'Russian (Kazakhstan)',
        langIso: 'ru_KZ',
    },
    {
        name: 'Kenya',
        officialName: 'Kenya',
        numeric: '404',
        alpha2: 'KE',
        alpha3: 'KEN',
        currencyName: 'Kenyan Shilling',
        currencyAlphabeticCode: 'KES',
        langName: 'Swahili (Kenya)',
        langIso: 'sw_KE',
    },
    {
        name: 'Kuwait',
        officialName: 'Kuwait',
        numeric: '414',
        alpha2: 'KW',
        alpha3: 'KWT',
        currencyName: 'Kuwaiti Dinar',
        currencyAlphabeticCode: 'KWD',
        langName: 'Arabic (Kuwait)',
        langIso: 'ar_KW',
    },
    {
        name: 'Kuwait',
        officialName: 'Kuwait',
        numeric: '414',
        alpha2: 'KW',
        alpha3: 'KWT',
        currencyName: 'Kuwaiti Dinar',
        currencyAlphabeticCode: 'KWD',
        langName: 'English (Kuwait)',
        langIso: 'en_KW',
    },
    {
        name: 'Kyrgyzstan',
        officialName: 'Kyrgyzstan',
        numeric: '417',
        alpha2: 'KG',
        alpha3: 'KGZ',
        currencyName: 'Som',
        currencyAlphabeticCode: 'KGS',
        langName: 'Kyrgyz (Kyrgyzstan)',
        langIso: 'ky_KG',
    },
    {
        name: 'Kyrgyzstan',
        officialName: 'Kyrgyzstan',
        numeric: '417',
        alpha2: 'KG',
        alpha3: 'KGZ',
        currencyName: 'Som',
        currencyAlphabeticCode: 'KGS',
        langName: 'Uzbek (Kyrgyzstan)',
        langIso: 'uz_KG',
    },
    {
        name: 'Kyrgyzstan',
        officialName: 'Kyrgyzstan',
        numeric: '417',
        alpha2: 'KG',
        alpha3: 'KGZ',
        currencyName: 'Som',
        currencyAlphabeticCode: 'KGS',
        langName: 'Russian (Kyrgyzstan)',
        langIso: 'ru_KG',
    },
    {
        name: 'Laos',
        officialName: "Lao People's Democratic Republic",
        numeric: '418',
        alpha2: 'LA',
        alpha3: 'LAO',
        currencyName: 'Lao Kip',
        currencyAlphabeticCode: 'LAK',
        langName: 'Lao (Laos)',
        langIso: 'lo_LA',
    },
    {
        name: 'Laos',
        officialName: "Lao People's Democratic Republic",
        numeric: '418',
        alpha2: 'LA',
        alpha3: 'LAO',
        currencyName: 'Lao Kip',
        currencyAlphabeticCode: 'LAK',
        langName: 'French (Laos)',
        langIso: 'fr_LA',
    },
    {
        name: 'Laos',
        officialName: "Lao People's Democratic Republic",
        numeric: '418',
        alpha2: 'LA',
        alpha3: 'LAO',
        currencyName: 'Lao Kip',
        currencyAlphabeticCode: 'LAK',
        langName: 'English (Laos)',
        langIso: 'en_LA',
    },
    {
        name: 'Latvia',
        officialName: 'Latvia',
        numeric: '428',
        alpha2: 'LV',
        alpha3: 'LVA',
        currencyName: 'Euro',
        currencyAlphabeticCode: 'EUR',
        langName: 'Latvian (Latvia)',
        langIso: 'lv_LV',
    },
    {
        name: 'Latvia',
        officialName: 'Latvia',
        numeric: '428',
        alpha2: 'LV',
        alpha3: 'LVA',
        currencyName: 'Euro',
        currencyAlphabeticCode: 'EUR',
        langName: 'Russian (Latvia)',
        langIso: 'ru_LV',
    },
    {
        name: 'Latvia',
        officialName: 'Latvia',
        numeric: '428',
        alpha2: 'LV',
        alpha3: 'LVA',
        currencyName: 'Euro',
        currencyAlphabeticCode: 'EUR',
        langName: 'Lithuanian (Latvia)',
        langIso: 'lt_LV',
    },
    {
        name: 'Lebanon',
        officialName: 'Lebanon',
        numeric: '422',
        alpha2: 'LB',
        alpha3: 'LBN',
        currencyName: 'Lebanese Pound',
        currencyAlphabeticCode: 'LBP',
        langName: 'Arabic (Lebanon)',
        langIso: 'ar_LB',
    },
    {
        name: 'Lebanon',
        officialName: 'Lebanon',
        numeric: '422',
        alpha2: 'LB',
        alpha3: 'LBN',
        currencyName: 'Lebanese Pound',
        currencyAlphabeticCode: 'LBP',
        langName: 'English (Lebanon)',
        langIso: 'en_LB',
    },
    {
        name: 'Lebanon',
        officialName: 'Lebanon',
        numeric: '422',
        alpha2: 'LB',
        alpha3: 'LBN',
        currencyName: 'Lebanese Pound',
        currencyAlphabeticCode: 'LBP',
        langName: 'Armenian (Lebanon)',
        langIso: 'hy_LB',
    },
    {
        name: 'Lesotho',
        officialName: 'Lesotho',
        numeric: '426',
        alpha2: 'LS',
        alpha3: 'LSO',
        currencyName: 'Loti,Rand',
        currencyAlphabeticCode: 'LSL,ZAR',
        langName: 'Southern Sotho (Lesotho)',
        langIso: 'st_LS',
    },
    {
        name: 'Lesotho',
        officialName: 'Lesotho',
        numeric: '426',
        alpha2: 'LS',
        alpha3: 'LSO',
        currencyName: 'Loti,Rand',
        currencyAlphabeticCode: 'LSL,ZAR',
        langName: 'Zulu (Lesotho)',
        langIso: 'zu_LS',
    },
    {
        name: 'Lesotho',
        officialName: 'Lesotho',
        numeric: '426',
        alpha2: 'LS',
        alpha3: 'LSO',
        currencyName: 'Loti,Rand',
        currencyAlphabeticCode: 'LSL,ZAR',
        langName: 'Xhosa (Lesotho)',
        langIso: 'xh_LS',
    },
    {
        name: 'Libya',
        officialName: 'Libya',
        numeric: '434',
        alpha2: 'LY',
        alpha3: 'LBY',
        currencyName: 'Libyan Dinar',
        currencyAlphabeticCode: 'LYD',
        langName: 'Arabic (Libya)',
        langIso: 'ar_LY',
    },
    {
        name: 'Libya',
        officialName: 'Libya',
        numeric: '434',
        alpha2: 'LY',
        alpha3: 'LBY',
        currencyName: 'Libyan Dinar',
        currencyAlphabeticCode: 'LYD',
        langName: 'Italian (Libya)',
        langIso: 'it_LY',
    },
    {
        name: 'Libya',
        officialName: 'Libya',
        numeric: '434',
        alpha2: 'LY',
        alpha3: 'LBY',
        currencyName: 'Libyan Dinar',
        currencyAlphabeticCode: 'LYD',
        langName: 'English (Libya)',
        langIso: 'en_LY',
    },
    {
        name: 'Liechtenstein',
        officialName: 'Liechtenstein',
        numeric: '438',
        alpha2: 'LI',
        alpha3: 'LIE',
        currencyName: 'Swiss Franc',
        currencyAlphabeticCode: 'CHF',
        langName: 'German (Liechtenstein)',
        langIso: 'de_LI',
    },
    {
        name: 'Lithuania',
        officialName: 'Lithuania',
        numeric: '440',
        alpha2: 'LT',
        alpha3: 'LTU',
        currencyName: 'Euro',
        currencyAlphabeticCode: 'EUR',
        langName: 'Lithuanian (Lithuania)',
        langIso: 'lt_LT',
    },
    {
        name: 'Lithuania',
        officialName: 'Lithuania',
        numeric: '440',
        alpha2: 'LT',
        alpha3: 'LTU',
        currencyName: 'Euro',
        currencyAlphabeticCode: 'EUR',
        langName: 'Russian (Lithuania)',
        langIso: 'ru_LT',
    },
    {
        name: 'Lithuania',
        officialName: 'Lithuania',
        numeric: '440',
        alpha2: 'LT',
        alpha3: 'LTU',
        currencyName: 'Euro',
        currencyAlphabeticCode: 'EUR',
        langName: 'Polish (Lithuania)',
        langIso: 'pl_LT',
    },
    {
        name: 'Luxembourg',
        officialName: 'Luxembourg',
        numeric: '442',
        alpha2: 'LU',
        alpha3: 'LUX',
        currencyName: 'Euro',
        currencyAlphabeticCode: 'EUR',
        langName: 'Luxembourgish (Luxembourg)',
        langIso: 'lb_LU',
    },
    {
        name: 'Luxembourg',
        officialName: 'Luxembourg',
        numeric: '442',
        alpha2: 'LU',
        alpha3: 'LUX',
        currencyName: 'Euro',
        currencyAlphabeticCode: 'EUR',
        langName: 'German (Luxembourg)',
        langIso: 'de_LU',
    },
    {
        name: 'Luxembourg',
        officialName: 'Luxembourg',
        numeric: '442',
        alpha2: 'LU',
        alpha3: 'LUX',
        currencyName: 'Euro',
        currencyAlphabeticCode: 'EUR',
        langName: 'French (Luxembourg)',
        langIso: 'fr_LU',
    },
    {
        name: 'Madagascar',
        officialName: 'Madagascar',
        numeric: '450',
        alpha2: 'MG',
        alpha3: 'MDG',
        currencyName: 'Malagasy Ariary',
        currencyAlphabeticCode: 'MGA',
        langName: 'French (Madagascar)',
        langIso: 'fr_MG',
    },
    {
        name: 'Madagascar',
        officialName: 'Madagascar',
        numeric: '450',
        alpha2: 'MG',
        alpha3: 'MDG',
        currencyName: 'Malagasy Ariary',
        currencyAlphabeticCode: 'MGA',
        langName: 'Malagasy (Madagascar)',
        langIso: 'mg_MG',
    },
    {
        name: 'Malawi',
        officialName: 'Malawi',
        numeric: '454',
        alpha2: 'MW',
        alpha3: 'MWI',
        currencyName: 'Malawi Kwacha',
        currencyAlphabeticCode: 'MWK',
        langName: 'Chichewa (Malawi)',
        langIso: 'ny_MW',
    },
    {
        name: 'Malawi',
        officialName: 'Malawi',
        numeric: '454',
        alpha2: 'MW',
        alpha3: 'MWI',
        currencyName: 'Malawi Kwacha',
        currencyAlphabeticCode: 'MWK',
        langName: 'Sena (Malawi)',
        langIso: 'swk_MW',
    },
    {
        name: 'Malaysia',
        officialName: 'Malaysia',
        numeric: '458',
        alpha2: 'MY',
        alpha3: 'MYS',
        currencyName: 'Malaysian Ringgit',
        currencyAlphabeticCode: 'MYR',
        langName: 'Malay (Malaysia)',
        langIso: 'ms_MY',
    },
    {
        name: 'Malaysia',
        officialName: 'Malaysia',
        numeric: '458',
        alpha2: 'MY',
        alpha3: 'MYS',
        currencyName: 'Malaysian Ringgit',
        currencyAlphabeticCode: 'MYR',
        langName: 'English (Malaysia)',
        langIso: 'en_MY',
    },
    {
        name: 'Malaysia',
        officialName: 'Malaysia',
        numeric: '458',
        alpha2: 'MY',
        alpha3: 'MYS',
        currencyName: 'Malaysian Ringgit',
        currencyAlphabeticCode: 'MYR',
        langName: 'Tamil (Malaysia)',
        langIso: 'ta_MY',
    },
    {
        name: 'Malaysia',
        officialName: 'Malaysia',
        numeric: '458',
        alpha2: 'MY',
        alpha3: 'MYS',
        currencyName: 'Malaysian Ringgit',
        currencyAlphabeticCode: 'MYR',
        langName: 'Telugu (Malaysia)',
        langIso: 'te_MY',
    },
    {
        name: 'Malaysia',
        officialName: 'Malaysia',
        numeric: '458',
        alpha2: 'MY',
        alpha3: 'MYS',
        currencyName: 'Malaysian Ringgit',
        currencyAlphabeticCode: 'MYR',
        langName: 'Malayalam (Malaysia)',
        langIso: 'ml_MY',
    },
    {
        name: 'Malaysia',
        officialName: 'Malaysia',
        numeric: '458',
        alpha2: 'MY',
        alpha3: 'MYS',
        currencyName: 'Malaysian Ringgit',
        currencyAlphabeticCode: 'MYR',
        langName: 'Punjabi (Malaysia)',
        langIso: 'pa_MY',
    },
    {
        name: 'Malaysia',
        officialName: 'Malaysia',
        numeric: '458',
        alpha2: 'MY',
        alpha3: 'MYS',
        currencyName: 'Malaysian Ringgit',
        currencyAlphabeticCode: 'MYR',
        langName: 'Thai (Malaysia)',
        langIso: 'th_MY',
    },
    {
        name: 'Maldives',
        officialName: 'Maldives',
        numeric: '462',
        alpha2: 'MV',
        alpha3: 'MDV',
        currencyName: 'Rufiyaa',
        currencyAlphabeticCode: 'MVR',
        langName: 'Divehi (Maldives)',
        langIso: 'dv_MV',
    },
    {
        name: 'Maldives',
        officialName: 'Maldives',
        numeric: '462',
        alpha2: 'MV',
        alpha3: 'MDV',
        currencyName: 'Rufiyaa',
        currencyAlphabeticCode: 'MVR',
        langName: 'English (Maldives)',
        langIso: 'en_MV',
    },
    {
        name: 'Mali',
        officialName: 'Mali',
        numeric: '466',
        alpha2: 'ML',
        alpha3: 'MLI',
        currencyName: 'CFA Franc BCEAO',
        currencyAlphabeticCode: 'XOF',
        langName: 'French (Mali)',
        langIso: 'fr_ML',
    },
    {
        name: 'Mali',
        officialName: 'Mali',
        numeric: '466',
        alpha2: 'ML',
        alpha3: 'MLI',
        currencyName: 'CFA Franc BCEAO',
        currencyAlphabeticCode: 'XOF',
        langName: 'Bambara (Mali)',
        langIso: 'bm_ML',
    },
    {
        name: 'Malta',
        officialName: 'Malta',
        numeric: '470',
        alpha2: 'MT',
        alpha3: 'MLT',
        currencyName: 'Euro',
        currencyAlphabeticCode: 'EUR',
        langName: 'English (Malta)',
        langIso: 'en_MT',
    },
    {
        name: 'Marshall Islands',
        officialName: 'Marshall Islands',
        numeric: '584',
        alpha2: 'MH',
        alpha3: 'MHL',
        currencyName: 'US Dollar',
        currencyAlphabeticCode: 'USD',
        langName: 'Marshallese (Marshall Islands)',
        langIso: 'mh_MH',
    },
    {
        name: 'Marshall Islands',
        officialName: 'Marshall Islands',
        numeric: '584',
        alpha2: 'MH',
        alpha3: 'MHL',
        currencyName: 'US Dollar',
        currencyAlphabeticCode: 'USD',
        langName: 'English (Marshall Islands)',
        langIso: 'en_MH',
    },
    {
        name: 'Martinique',
        officialName: 'Martinique',
        numeric: '474',
        alpha2: 'MQ',
        alpha3: 'MTQ',
        currencyName: 'Euro',
        currencyAlphabeticCode: 'EUR',
        langName: 'French (Martinique)',
        langIso: 'fr_MQ',
    },
    {
        name: 'Mauritania',
        officialName: 'Mauritania',
        numeric: '478',
        alpha2: 'MR',
        alpha3: 'MRT',
        currencyName: 'Ouguiya',
        currencyAlphabeticCode: 'MRU',
        langName: 'French (Mauritania)',
        langIso: 'fr_MR',
    },
    {
        name: 'Mauritania',
        officialName: 'Mauritania',
        numeric: '478',
        alpha2: 'MR',
        alpha3: 'MRT',
        currencyName: 'Ouguiya',
        currencyAlphabeticCode: 'MRU',
        langName: 'Wolof (Mauritania)',
        langIso: 'wo_MR',
    },
    {
        name: 'Mauritius',
        officialName: 'Mauritius',
        numeric: '480',
        alpha2: 'MU',
        alpha3: 'MUS',
        currencyName: 'Mauritius Rupee',
        currencyAlphabeticCode: 'MUR',
        langName: 'English (Mauritius)',
        langIso: 'en_MU',
    },
    {
        name: 'Mauritius',
        officialName: 'Mauritius',
        numeric: '480',
        alpha2: 'MU',
        alpha3: 'MUS',
        currencyName: 'Mauritius Rupee',
        currencyAlphabeticCode: 'MUR',
        langName: 'French (Mauritius)',
        langIso: 'fr_MU',
    },
    {
        name: 'Mayotte',
        officialName: 'Mayotte',
        numeric: '175',
        alpha2: 'YT',
        alpha3: 'MYT',
        currencyName: 'Euro',
        currencyAlphabeticCode: 'EUR',
        langName: 'French (Mayotte)',
        langIso: 'fr_YT',
    },
    {
        name: 'Mexico',
        officialName: 'Mexico',
        numeric: '484',
        alpha2: 'MX',
        alpha3: 'MEX',
        currencyName: 'Mexican Peso',
        currencyAlphabeticCode: 'MXN',
        langName: 'Spanish (Mexico)',
        langIso: 'es_MX',
    },
    {
        name: 'Monaco',
        officialName: 'Monaco',
        numeric: '492',
        alpha2: 'MC',
        alpha3: 'MCO',
        currencyName: 'Euro',
        currencyAlphabeticCode: 'EUR',
        langName: 'French (Monaco)',
        langIso: 'fr_MC',
    },
    {
        name: 'Monaco',
        officialName: 'Monaco',
        numeric: '492',
        alpha2: 'MC',
        alpha3: 'MCO',
        currencyName: 'Euro',
        currencyAlphabeticCode: 'EUR',
        langName: 'English (Monaco)',
        langIso: 'en_MC',
    },
    {
        name: 'Monaco',
        officialName: 'Monaco',
        numeric: '492',
        alpha2: 'MC',
        alpha3: 'MCO',
        currencyName: 'Euro',
        currencyAlphabeticCode: 'EUR',
        langName: 'Italian (Monaco)',
        langIso: 'it_MC',
    },
    {
        name: 'Mongolia',
        officialName: 'Mongolia',
        numeric: '496',
        alpha2: 'MN',
        alpha3: 'MNG',
        currencyName: 'Tugrik',
        currencyAlphabeticCode: 'MNT',
        langName: 'Russian (Mongolia)',
        langIso: 'ru_MN',
    },
    {
        name: 'Montenegro',
        officialName: 'Montenegro',
        numeric: '499',
        alpha2: 'ME',
        alpha3: 'MNE',
        currencyName: 'Euro',
        currencyAlphabeticCode: 'EUR',
        langName: 'Serbian (Montenegro)',
        langIso: 'sr_ME',
    },
    {
        name: 'Montenegro',
        officialName: 'Montenegro',
        numeric: '499',
        alpha2: 'ME',
        alpha3: 'MNE',
        currencyName: 'Euro',
        currencyAlphabeticCode: 'EUR',
        langName: 'Hungarian (Montenegro)',
        langIso: 'hu_ME',
    },
    {
        name: 'Montenegro',
        officialName: 'Montenegro',
        numeric: '499',
        alpha2: 'ME',
        alpha3: 'MNE',
        currencyName: 'Euro',
        currencyAlphabeticCode: 'EUR',
        langName: 'Albanian (Montenegro)',
        langIso: 'sq_ME',
    },
    {
        name: 'Montenegro',
        officialName: 'Montenegro',
        numeric: '499',
        alpha2: 'ME',
        alpha3: 'MNE',
        currencyName: 'Euro',
        currencyAlphabeticCode: 'EUR',
        langName: 'Croatian (Montenegro)',
        langIso: 'hr_ME',
    },
    {
        name: 'Morocco',
        officialName: 'Morocco',
        numeric: '504',
        alpha2: 'MA',
        alpha3: 'MAR',
        currencyName: 'Moroccan Dirham',
        currencyAlphabeticCode: 'MAD',
        langName: 'Arabic (Morocco)',
        langIso: 'ar_MA',
    },
    {
        name: 'Morocco',
        officialName: 'Morocco',
        numeric: '504',
        alpha2: 'MA',
        alpha3: 'MAR',
        currencyName: 'Moroccan Dirham',
        currencyAlphabeticCode: 'MAD',
        langName: 'French (Morocco)',
        langIso: 'fr_MA',
    },
    {
        name: 'Mozambique',
        officialName: 'Mozambique',
        numeric: '508',
        alpha2: 'MZ',
        alpha3: 'MOZ',
        currencyName: 'Mozambique Metical',
        currencyAlphabeticCode: 'MZN',
        langName: 'Portuguese (Mozambique)',
        langIso: 'pt_MZ',
    },
    {
        name: 'Myanmar',
        officialName: 'Myanmar',
        numeric: '104',
        alpha2: 'MM',
        alpha3: 'MMR',
        currencyName: 'Kyat',
        currencyAlphabeticCode: 'MMK',
        langName: 'Burmese (Myanmar)',
        langIso: 'my_MM',
    },
    {
        name: 'Namibia',
        officialName: 'Namibia',
        numeric: '516',
        alpha2: 'NA',
        alpha3: 'NAM',
        currencyName: 'Namibia Dollar,Rand',
        currencyAlphabeticCode: 'NAD,ZAR',
        langName: 'English (Namibia)',
        langIso: 'en_NA',
    },
    {
        name: 'Namibia',
        officialName: 'Namibia',
        numeric: '516',
        alpha2: 'NA',
        alpha3: 'NAM',
        currencyName: 'Namibia Dollar,Rand',
        currencyAlphabeticCode: 'NAD,ZAR',
        langName: 'Afrikaans (Namibia)',
        langIso: 'af_NA',
    },
    {
        name: 'Namibia',
        officialName: 'Namibia',
        numeric: '516',
        alpha2: 'NA',
        alpha3: 'NAM',
        currencyName: 'Namibia Dollar,Rand',
        currencyAlphabeticCode: 'NAD,ZAR',
        langName: 'German (Namibia)',
        langIso: 'de_NA',
    },
    {
        name: 'Namibia',
        officialName: 'Namibia',
        numeric: '516',
        alpha2: 'NA',
        alpha3: 'NAM',
        currencyName: 'Namibia Dollar,Rand',
        currencyAlphabeticCode: 'NAD,ZAR',
        langName: 'Herero (Namibia)',
        langIso: 'hz_NA',
    },
    {
        name: 'Namibia',
        officialName: 'Namibia',
        numeric: '516',
        alpha2: 'NA',
        alpha3: 'NAM',
        currencyName: 'Namibia Dollar,Rand',
        currencyAlphabeticCode: 'NAD,ZAR',
        langName: 'Nama (Namibia)',
        langIso: 'naq_NA',
    },
    {
        name: 'Nauru',
        officialName: 'Nauru',
        numeric: '520',
        alpha2: 'NR',
        alpha3: 'NRU',
        currencyName: 'Australian Dollar',
        currencyAlphabeticCode: 'AUD',
        langName: 'Nauru (Nauru)',
        langIso: 'na_NR',
    },
    {
        name: 'Nepal',
        officialName: 'Nepal',
        numeric: '524',
        alpha2: 'NP',
        alpha3: 'NPL',
        currencyName: 'Nepalese Rupee',
        currencyAlphabeticCode: 'NPR',
        langName: 'Nepali (Nepal)',
        langIso: 'ne_NP',
    },
    {
        name: 'Nepal',
        officialName: 'Nepal',
        numeric: '524',
        alpha2: 'NP',
        alpha3: 'NPL',
        currencyName: 'Nepalese Rupee',
        currencyAlphabeticCode: 'NPR',
        langName: 'English (Nepal)',
        langIso: 'en_NP',
    },
    {
        name: 'Netherlands',
        officialName: 'Netherlands',
        numeric: '528',
        alpha2: 'NL',
        alpha3: 'NLD',
        currencyName: 'Euro',
        currencyAlphabeticCode: 'EUR',
        langName: 'Dutch (Netherlands)',
        langIso: 'nl_NL',
    },
    {
        name: 'Netherlands',
        officialName: 'Netherlands',
        numeric: '528',
        alpha2: 'NL',
        alpha3: 'NLD',
        currencyName: 'Euro',
        currencyAlphabeticCode: 'EUR',
        langName: 'Frisian',
        langIso: 'fy_NL',
    },
    {
        name: 'New Zealand',
        officialName: 'New Zealand',
        numeric: '554',
        alpha2: 'NZ',
        alpha3: 'NZL',
        currencyName: 'New Zealand Dollar',
        currencyAlphabeticCode: 'NZD',
        langName: 'English (New Zealand)',
        langIso: 'en_NZ',
    },
    {
        name: 'Nicaragua',
        officialName: 'Nicaragua',
        numeric: '558',
        alpha2: 'NI',
        alpha3: 'NIC',
        currencyName: 'Cordoba Oro',
        currencyAlphabeticCode: 'NIO',
        langName: 'Spanish (Nicaragua)',
        langIso: 'es_NI',
    },
    {
        name: 'Nicaragua',
        officialName: 'Nicaragua',
        numeric: '558',
        alpha2: 'NI',
        alpha3: 'NIC',
        currencyName: 'Cordoba Oro',
        currencyAlphabeticCode: 'NIO',
        langName: 'English (Nicaragua)',
        langIso: 'en_NI',
    },
    {
        name: 'Niger',
        officialName: 'Niger',
        numeric: '562',
        alpha2: 'NE',
        alpha3: 'NER',
        currencyName: 'CFA Franc BCEAO',
        currencyAlphabeticCode: 'XOF',
        langName: 'French (Niger)',
        langIso: 'fr_NE',
    },
    {
        name: 'Niger',
        officialName: 'Niger',
        numeric: '562',
        alpha2: 'NE',
        alpha3: 'NER',
        currencyName: 'CFA Franc BCEAO',
        currencyAlphabeticCode: 'XOF',
        langName: 'Hausa (Niger)',
        langIso: 'ha_NE',
    },
    {
        name: 'Niger',
        officialName: 'Niger',
        numeric: '562',
        alpha2: 'NE',
        alpha3: 'NER',
        currencyName: 'CFA Franc BCEAO',
        currencyAlphabeticCode: 'XOF',
        langName: 'Kanuri (Niger)',
        langIso: 'kr_NE',
    },
    {
        name: 'Niger',
        officialName: 'Niger',
        numeric: '562',
        alpha2: 'NE',
        alpha3: 'NER',
        currencyName: 'CFA Franc BCEAO',
        currencyAlphabeticCode: 'XOF',
        langName: 'Zarma (Niger)',
        langIso: 'dje_NE',
    },
    {
        name: 'Nigeria',
        officialName: 'Nigeria',
        numeric: '566',
        alpha2: 'NG',
        alpha3: 'NGA',
        currencyName: 'Naira',
        currencyAlphabeticCode: 'NGN',
        langName: 'English (Nigeria)',
        langIso: 'en_NG',
    },
    {
        name: 'Nigeria',
        officialName: 'Nigeria',
        numeric: '566',
        alpha2: 'NG',
        alpha3: 'NGA',
        currencyName: 'Naira',
        currencyAlphabeticCode: 'NGN',
        langName: 'Hausa (Nigeria)',
        langIso: 'ha_NG',
    },
    {
        name: 'Nigeria',
        officialName: 'Nigeria',
        numeric: '566',
        alpha2: 'NG',
        alpha3: 'NGA',
        currencyName: 'Naira',
        currencyAlphabeticCode: 'NGN',
        langName: 'Yoruba (Nigeria)',
        langIso: 'yo_NG',
    },
    {
        name: 'Nigeria',
        officialName: 'Nigeria',
        numeric: '566',
        alpha2: 'NG',
        alpha3: 'NGA',
        currencyName: 'Naira',
        currencyAlphabeticCode: 'NGN',
        langName: 'Igbo (Nigeria)',
        langIso: 'ig_NG',
    },
    {
        name: 'Nigeria',
        officialName: 'Nigeria',
        numeric: '566',
        alpha2: 'NG',
        alpha3: 'NGA',
        currencyName: 'Naira',
        currencyAlphabeticCode: 'NGN',
        langName: 'Fulah (Nigeria)',
        langIso: 'ff_NG',
    },
    {
        name: 'Northern Mariana Islands',
        officialName: 'Northern Mariana Islands',
        numeric: '580',
        alpha2: 'MP',
        alpha3: 'MNP',
        currencyName: 'US Dollar',
        currencyAlphabeticCode: 'USD',
        langName: 'Filipino (Northern Mariana Islands)',
        langIso: 'fil_MP',
    },
    {
        name: 'Northern Mariana Islands',
        officialName: 'Northern Mariana Islands',
        numeric: '580',
        alpha2: 'MP',
        alpha3: 'MNP',
        currencyName: 'US Dollar',
        currencyAlphabeticCode: 'USD',
        langName: 'Tagalog (Northern Mariana Islands)',
        langIso: 'tl_MP',
    },
    {
        name: 'Northern Mariana Islands',
        officialName: 'Northern Mariana Islands',
        numeric: '580',
        alpha2: 'MP',
        alpha3: 'MNP',
        currencyName: 'US Dollar',
        currencyAlphabeticCode: 'USD',
        langName: 'English (Northern Mariana Islands)',
        langIso: 'en_MP',
    },
    {
        name: 'Norway',
        officialName: 'Norway',
        numeric: '578',
        alpha2: 'NO',
        alpha3: 'NOR',
        currencyName: 'Norwegian Krone',
        currencyAlphabeticCode: 'NOK',
        langName: 'Norwegian (Norway)',
        langIso: 'no_NO',
    },
    {
        name: 'Norway',
        officialName: 'Norway',
        numeric: '578',
        alpha2: 'NO',
        alpha3: 'NOR',
        currencyName: 'Norwegian Krone',
        currencyAlphabeticCode: 'NOK',
        langName: 'Norwegian Bokmål (Norway)',
        langIso: 'nb_NO',
    },
    {
        name: 'Norway',
        officialName: 'Norway',
        numeric: '578',
        alpha2: 'NO',
        alpha3: 'NOR',
        currencyName: 'Norwegian Krone',
        currencyAlphabeticCode: 'NOK',
        langName: 'Norwegian Nynorsk (Norway)',
        langIso: 'nn_NO',
    },
    {
        name: 'Norway',
        officialName: 'Norway',
        numeric: '578',
        alpha2: 'NO',
        alpha3: 'NOR',
        currencyName: 'Norwegian Krone',
        currencyAlphabeticCode: 'NOK',
        langName: 'Northern Sami (Norway)',
        langIso: 'se_NO',
    },
    {
        name: 'Norway',
        officialName: 'Norway',
        numeric: '578',
        alpha2: 'NO',
        alpha3: 'NOR',
        currencyName: 'Norwegian Krone',
        currencyAlphabeticCode: 'NOK',
        langName: 'Finnish (Norway)',
        langIso: 'fi_NO',
    },
    {
        name: 'Oman',
        officialName: 'Oman',
        numeric: '512',
        alpha2: 'OM',
        alpha3: 'OMN',
        currencyName: 'Rial Omani',
        currencyAlphabeticCode: 'OMR',
        langName: 'Arabic (Oman)',
        langIso: 'ar_OM',
    },
    {
        name: 'Oman',
        officialName: 'Oman',
        numeric: '512',
        alpha2: 'OM',
        alpha3: 'OMN',
        currencyName: 'Rial Omani',
        currencyAlphabeticCode: 'OMR',
        langName: 'English (Oman)',
        langIso: 'en_OM',
    },
    {
        name: 'Oman',
        officialName: 'Oman',
        numeric: '512',
        alpha2: 'OM',
        alpha3: 'OMN',
        currencyName: 'Rial Omani',
        currencyAlphabeticCode: 'OMR',
        langName: 'Urdu (Oman)',
        langIso: 'ur_OM',
    },
    {
        name: 'Pakistan',
        officialName: 'Pakistan',
        numeric: '586',
        alpha2: 'PK',
        alpha3: 'PAK',
        currencyName: 'Pakistan Rupee',
        currencyAlphabeticCode: 'PKR',
        langName: 'Urdu (Pakistan)',
        langIso: 'ur_PK',
    },
    {
        name: 'Pakistan',
        officialName: 'Pakistan',
        numeric: '586',
        alpha2: 'PK',
        alpha3: 'PAK',
        currencyName: 'Pakistan Rupee',
        currencyAlphabeticCode: 'PKR',
        langName: 'English (Pakistan)',
        langIso: 'en_PK',
    },
    {
        name: 'Pakistan',
        officialName: 'Pakistan',
        numeric: '586',
        alpha2: 'PK',
        alpha3: 'PAK',
        currencyName: 'Pakistan Rupee',
        currencyAlphabeticCode: 'PKR',
        langName: 'Punjabi (Pakistan)',
        langIso: 'pa_PK',
    },
    {
        name: 'Pakistan',
        officialName: 'Pakistan',
        numeric: '586',
        alpha2: 'PK',
        alpha3: 'PAK',
        currencyName: 'Pakistan Rupee',
        currencyAlphabeticCode: 'PKR',
        langName: 'Sindhi (Pakistan)',
        langIso: 'sd_PK',
    },
    {
        name: 'Palau',
        officialName: 'Palau',
        numeric: '585',
        alpha2: 'PW',
        alpha3: 'PLW',
        currencyName: 'US Dollar',
        currencyAlphabeticCode: 'USD',
        langName: 'Japanese (Palau)',
        langIso: 'ja_PW',
    },
    {
        name: 'Palau',
        officialName: 'Palau',
        numeric: '585',
        alpha2: 'PW',
        alpha3: 'PLW',
        currencyName: 'US Dollar',
        currencyAlphabeticCode: 'USD',
        langName: 'Filipino (Palau)',
        langIso: 'fil_PW',
    },
    {
        name: 'Panama',
        officialName: 'Panama',
        numeric: '591',
        alpha2: 'PA',
        alpha3: 'PAN',
        currencyName: 'Balboa,US Dollar',
        currencyAlphabeticCode: 'PAB,USD',
        langName: 'Spanish (Panama)',
        langIso: 'es_PA',
    },
    {
        name: 'Panama',
        officialName: 'Panama',
        numeric: '591',
        alpha2: 'PA',
        alpha3: 'PAN',
        currencyName: 'Balboa,US Dollar',
        currencyAlphabeticCode: 'PAB,USD',
        langName: 'English (Panama)',
        langIso: 'en_PA',
    },
    {
        name: 'Papua New Guinea',
        officialName: 'Papua New Guinea',
        numeric: '598',
        alpha2: 'PG',
        alpha3: 'PNG',
        currencyName: 'Kina',
        currencyAlphabeticCode: 'PGK',
        langName: 'Hiri Motu (Papua New Guinea)',
        langIso: 'ho_PG',
    },
    {
        name: 'Paraguay',
        officialName: 'Paraguay',
        numeric: '600',
        alpha2: 'PY',
        alpha3: 'PRY',
        currencyName: 'Guarani',
        currencyAlphabeticCode: 'PYG',
        langName: 'Spanish (Paraguay)',
        langIso: 'es_PY',
    },
    {
        name: 'Paraguay',
        officialName: 'Paraguay',
        numeric: '600',
        alpha2: 'PY',
        alpha3: 'PRY',
        currencyName: 'Guarani',
        currencyAlphabeticCode: 'PYG',
        langName: 'Guarani (Paraguay)',
        langIso: 'gn_PY',
    },
    {
        name: 'Peru',
        officialName: 'Peru',
        numeric: '604',
        alpha2: 'PE',
        alpha3: 'PER',
        currencyName: 'Sol',
        currencyAlphabeticCode: 'PEN',
        langName: 'Spanish (Peru)',
        langIso: 'es_PE',
    },
    {
        name: 'Peru',
        officialName: 'Peru',
        numeric: '604',
        alpha2: 'PE',
        alpha3: 'PER',
        currencyName: 'Sol',
        currencyAlphabeticCode: 'PEN',
        langName: 'Quechua (Peru)',
        langIso: 'qu_PE',
    },
    {
        name: 'Peru',
        officialName: 'Peru',
        numeric: '604',
        alpha2: 'PE',
        alpha3: 'PER',
        currencyName: 'Sol',
        currencyAlphabeticCode: 'PEN',
        langName: 'Aymara (Peru)',
        langIso: 'ay_PE',
    },
    {
        name: 'Philippines',
        officialName: 'Philippines',
        numeric: '608',
        alpha2: 'PH',
        alpha3: 'PHL',
        currencyName: 'Philippine Peso',
        currencyAlphabeticCode: 'PHP',
        langName: 'Tagalog (Philippines)',
        langIso: 'tl_PH',
    },
    {
        name: 'Philippines',
        officialName: 'Philippines',
        numeric: '608',
        alpha2: 'PH',
        alpha3: 'PHL',
        currencyName: 'Philippine Peso',
        currencyAlphabeticCode: 'PHP',
        langName: 'English (Philippines)',
        langIso: 'en_PH',
    },
    {
        name: 'Philippines',
        officialName: 'Philippines',
        numeric: '608',
        alpha2: 'PH',
        alpha3: 'PHL',
        currencyName: 'Philippine Peso',
        currencyAlphabeticCode: 'PHP',
        langName: 'Filipino (Philippines)',
        langIso: 'fil_PH',
    },
    {
        name: 'Philippines',
        officialName: 'Philippines',
        numeric: '608',
        alpha2: 'PH',
        alpha3: 'PHL',
        currencyName: 'Philippine Peso',
        currencyAlphabeticCode: 'PHP',
        langName: 'Cebuano (Philippines)',
        langIso: 'ceb_PH',
    },
    {
        name: 'Philippines',
        officialName: 'Philippines',
        numeric: '608',
        alpha2: 'PH',
        alpha3: 'PHL',
        currencyName: 'Philippine Peso',
        currencyAlphabeticCode: 'PHP',
        langName: 'Tausug (Philippines)',
        langIso: 'tsg_PH',
    },
    {
        name: 'Poland',
        officialName: 'Poland',
        numeric: '616',
        alpha2: 'PL',
        alpha3: 'POL',
        currencyName: 'Zloty',
        currencyAlphabeticCode: 'PLN',
        langName: 'Polish (Poland)',
        langIso: 'pl_PL',
    },
    {
        name: 'Puerto Rico',
        officialName: 'Puerto Rico',
        numeric: '630',
        alpha2: 'PR',
        alpha3: 'PRI',
        currencyName: 'US Dollar',
        currencyAlphabeticCode: 'USD',
        langName: 'Spanish (Puerto Rico)',
        langIso: 'es_PR',
    },
    {
        name: 'Qatar',
        officialName: 'Qatar',
        numeric: '634',
        alpha2: 'QA',
        alpha3: 'QAT',
        currencyName: 'Qatari Rial',
        currencyAlphabeticCode: 'QAR',
        langName: 'Arabic (Qatar)',
        langIso: 'ar_QA',
    },
    {
        name: 'Qatar',
        officialName: 'Qatar',
        numeric: '634',
        alpha2: 'QA',
        alpha3: 'QAT',
        currencyName: 'Qatari Rial',
        currencyAlphabeticCode: 'QAR',
        langName: 'Spanish (Qatar)',
        langIso: 'es_QA',
    },
    {
        name: 'South Korea',
        officialName: 'Republic of Korea',
        numeric: '410',
        alpha2: 'KR',
        alpha3: 'KOR',
        currencyName: 'Won',
        currencyAlphabeticCode: 'KRW',
        langName: 'Korean (Korea)',
        langIso: 'ko_KR',
    },
    {
        name: 'South Korea',
        officialName: 'Republic of Korea',
        numeric: '410',
        alpha2: 'KR',
        alpha3: 'KOR',
        currencyName: 'Won',
        currencyAlphabeticCode: 'KRW',
        langName: 'English (South Korea)',
        langIso: 'en_KR',
    },
    {
        name: 'Moldova',
        officialName: 'Republic of Moldova',
        numeric: '498',
        alpha2: 'MD',
        alpha3: 'MDA',
        currencyName: 'Moldovan Leu',
        currencyAlphabeticCode: 'MDL',
        langName: 'Romanian (Moldova)',
        langIso: 'ro_MD',
    },
    {
        name: 'Moldova',
        officialName: 'Republic of Moldova',
        numeric: '498',
        alpha2: 'MD',
        alpha3: 'MDA',
        currencyName: 'Moldovan Leu',
        currencyAlphabeticCode: 'MDL',
        langName: 'Russian (Moldova)',
        langIso: 'ru_MD',
    },
    {
        name: 'Moldova',
        officialName: 'Republic of Moldova',
        numeric: '498',
        alpha2: 'MD',
        alpha3: 'MDA',
        currencyName: 'Moldovan Leu',
        currencyAlphabeticCode: 'MDL',
        langName: 'Turkish (Moldova)',
        langIso: 'tr_MD',
    },
    {
        name: 'Romania',
        officialName: 'Romania',
        numeric: '642',
        alpha2: 'RO',
        alpha3: 'ROU',
        currencyName: 'Romanian Leu',
        currencyAlphabeticCode: 'RON',
        langName: 'Romanian (Romania)',
        langIso: 'ro_RO',
    },
    {
        name: 'Romania',
        officialName: 'Romania',
        numeric: '642',
        alpha2: 'RO',
        alpha3: 'ROU',
        currencyName: 'Romanian Leu',
        currencyAlphabeticCode: 'RON',
        langName: 'Hungarian (Romania)',
        langIso: 'hu_RO',
    },
    {
        name: 'Russia',
        officialName: 'Russian Federation',
        numeric: '643',
        alpha2: 'RU',
        alpha3: 'RUS',
        currencyName: 'Russian Ruble',
        currencyAlphabeticCode: 'RUB',
        langName: 'Tatar (Russia)',
        langIso: 'tt_RU',
    },
    {
        name: 'Russia',
        officialName: 'Russian Federation',
        numeric: '643',
        alpha2: 'RU',
        alpha3: 'RUS',
        currencyName: 'Russian Ruble',
        currencyAlphabeticCode: 'RUB',
        langName: 'Komi (Russia)',
        langIso: 'kv_RU',
    },
    {
        name: 'Russia',
        officialName: 'Russian Federation',
        numeric: '643',
        alpha2: 'RU',
        alpha3: 'RUS',
        currencyName: 'Russian Ruble',
        currencyAlphabeticCode: 'RUB',
        langName: 'Chechen (Russia)',
        langIso: 'ce_RU',
    },
    {
        name: 'Russia',
        officialName: 'Russian Federation',
        numeric: '643',
        alpha2: 'RU',
        alpha3: 'RUS',
        currencyName: 'Russian Ruble',
        currencyAlphabeticCode: 'RUB',
        langName: 'Bashkir (Russia)',
        langIso: 'ba_RU',
    },
    {
        name: 'Russia',
        officialName: 'Russian Federation',
        numeric: '643',
        alpha2: 'RU',
        alpha3: 'RUS',
        currencyName: 'Russian Ruble',
        currencyAlphabeticCode: 'RUB',
        langName: 'Avaric (Russia)',
        langIso: 'av_RU',
    },
    {
        name: 'Rwanda',
        officialName: 'Rwanda',
        numeric: '646',
        alpha2: 'RW',
        alpha3: 'RWA',
        currencyName: 'Rwanda Franc',
        currencyAlphabeticCode: 'RWF',
        langName: 'Kinyarwanda (Rwanda)',
        langIso: 'rw_RW',
    },
    {
        name: 'Rwanda',
        officialName: 'Rwanda',
        numeric: '646',
        alpha2: 'RW',
        alpha3: 'RWA',
        currencyName: 'Rwanda Franc',
        currencyAlphabeticCode: 'RWF',
        langName: 'French (Rwanda)',
        langIso: 'fr_RW',
    },
    {
        name: 'Rwanda',
        officialName: 'Rwanda',
        numeric: '646',
        alpha2: 'RW',
        alpha3: 'RWA',
        currencyName: 'Rwanda Franc',
        currencyAlphabeticCode: 'RWF',
        langName: 'Swahili (Rwanda)',
        langIso: 'sw_RW',
    },
    {
        name: 'Réunion',
        officialName: 'Réunion',
        numeric: '638',
        alpha2: 'RE',
        alpha3: 'REU',
        currencyName: 'Euro',
        currencyAlphabeticCode: 'EUR',
        langName: 'French (Réunion)',
        langIso: 'fr_RE',
    },
    {
        name: 'St. Barthélemy',
        officialName: 'Saint Barthélemy',
        numeric: '652',
        alpha2: 'BL',
        alpha3: 'BLM',
        currencyName: 'Euro',
        currencyAlphabeticCode: 'EUR',
        langName: 'French (St. Barthélemy)',
        langIso: 'fr_BL',
    },
    {
        name: 'St. Martin',
        officialName: 'Saint Martin (French Part)',
        numeric: '663',
        alpha2: 'MF',
        alpha3: 'MAF',
        currencyName: 'Euro',
        currencyAlphabeticCode: 'EUR',
        langName: 'French (St. Martin)',
        langIso: 'fr_MF',
    },
    {
        name: 'St. Vincent & Grenadines',
        officialName: 'Saint Vincent and the Grenadines',
        numeric: '670',
        alpha2: 'VC',
        alpha3: 'VCT',
        currencyName: 'East Caribbean Dollar',
        currencyAlphabeticCode: 'XCD',
        langName: 'French (St. Vincent & Grenadines)',
        langIso: 'fr_VC',
    },
    {
        name: 'Samoa',
        officialName: 'Samoa',
        numeric: '882',
        alpha2: 'WS',
        alpha3: 'WSM',
        currencyName: 'Tala',
        currencyAlphabeticCode: 'WST',
        langName: 'Samoan (Samoa)',
        langIso: 'sm_WS',
    },
    {
        name: 'São Tomé & Príncipe',
        officialName: 'Sao Tome and Principe',
        numeric: '678',
        alpha2: 'ST',
        alpha3: 'STP',
        currencyName: 'Dobra',
        currencyAlphabeticCode: 'STN',
        langName: 'Portuguese (São Tomé and Príncipe)',
        langIso: 'pt_ST',
    },
    {
        name: 'Saudi Arabia',
        officialName: 'Saudi Arabia',
        numeric: '682',
        alpha2: 'SA',
        alpha3: 'SAU',
        currencyName: 'Saudi Riyal',
        currencyAlphabeticCode: 'SAR',
        langName: 'Arabic (Saudi Arabia)',
        langIso: 'ar_SA',
    },
    {
        name: 'Senegal',
        officialName: 'Senegal',
        numeric: '686',
        alpha2: 'SN',
        alpha3: 'SEN',
        currencyName: 'CFA Franc BCEAO',
        currencyAlphabeticCode: 'XOF',
        langName: 'French (Senegal)',
        langIso: 'fr_SN',
    },
    {
        name: 'Senegal',
        officialName: 'Senegal',
        numeric: '686',
        alpha2: 'SN',
        alpha3: 'SEN',
        currencyName: 'CFA Franc BCEAO',
        currencyAlphabeticCode: 'XOF',
        langName: 'Wolof (Senegal)',
        langIso: 'wo_SN',
    },
    {
        name: 'Serbia',
        officialName: 'Serbia',
        numeric: '688',
        alpha2: 'RS',
        alpha3: 'SRB',
        currencyName: 'Serbian Dinar',
        currencyAlphabeticCode: 'RSD',
        langName: 'Serbian (Serbia)',
        langIso: 'sr_RS',
    },
    {
        name: 'Serbia',
        officialName: 'Serbia',
        numeric: '688',
        alpha2: 'RS',
        alpha3: 'SRB',
        currencyName: 'Serbian Dinar',
        currencyAlphabeticCode: 'RSD',
        langName: 'Hungarian (Serbia)',
        langIso: 'hu_RS',
    },
    {
        name: 'Singapore',
        officialName: 'Singapore',
        numeric: '702',
        alpha2: 'SG',
        alpha3: 'SGP',
        currencyName: 'Singapore Dollar',
        currencyAlphabeticCode: 'SGD',
        langName: 'English (Singapore)',
        langIso: 'en_SG',
    },
    {
        name: 'Singapore',
        officialName: 'Singapore',
        numeric: '702',
        alpha2: 'SG',
        alpha3: 'SGP',
        currencyName: 'Singapore Dollar',
        currencyAlphabeticCode: 'SGD',
        langName: 'Malay (Singapore)',
        langIso: 'ms_SG',
    },
    {
        name: 'Singapore',
        officialName: 'Singapore',
        numeric: '702',
        alpha2: 'SG',
        alpha3: 'SGP',
        currencyName: 'Singapore Dollar',
        currencyAlphabeticCode: 'SGD',
        langName: 'Tamil (Singapore)',
        langIso: 'ta_SG',
    },
    {
        name: 'Singapore',
        officialName: 'Singapore',
        numeric: '702',
        alpha2: 'SG',
        alpha3: 'SGP',
        currencyName: 'Singapore Dollar',
        currencyAlphabeticCode: 'SGD',
        langName: 'Chinese Simplified (Singapore)',
        langIso: 'zh_SG',
    },
    {
        name: 'Sint Maarten',
        officialName: 'Sint Maarten (Dutch part)',
        numeric: '534',
        alpha2: 'SX',
        alpha3: 'SXM',
        currencyName: 'Netherlands Antillean Guilder',
        currencyAlphabeticCode: 'ANG',
        langName: 'Dutch (Sint Maarten)',
        langIso: 'nl_SX',
    },
    {
        name: 'Sint Maarten',
        officialName: 'Sint Maarten (Dutch part)',
        numeric: '534',
        alpha2: 'SX',
        alpha3: 'SXM',
        currencyName: 'Netherlands Antillean Guilder',
        currencyAlphabeticCode: 'ANG',
        langName: 'English (Sint Maarten)',
        langIso: 'en_SX',
    },
    {
        name: 'Slovakia',
        officialName: 'Slovakia',
        numeric: '703',
        alpha2: 'SK',
        alpha3: 'SVK',
        currencyName: 'Euro',
        currencyAlphabeticCode: 'EUR',
        langName: 'Slovak (Slovakia)',
        langIso: 'sk_SK',
    },
    {
        name: 'Slovakia',
        officialName: 'Slovakia',
        numeric: '703',
        alpha2: 'SK',
        alpha3: 'SVK',
        currencyName: 'Euro',
        currencyAlphabeticCode: 'EUR',
        langName: 'Hungarian (Slovakia)',
        langIso: 'hu_SK',
    },
    {
        name: 'Slovenia',
        officialName: 'Slovenia',
        numeric: '705',
        alpha2: 'SI',
        alpha3: 'SVN',
        currencyName: 'Euro',
        currencyAlphabeticCode: 'EUR',
        langName: 'Slovenian (Slovenia)',
        langIso: 'sl_SI',
    },
    {
        name: 'Somalia',
        officialName: 'Somalia',
        numeric: '706',
        alpha2: 'SO',
        alpha3: 'SOM',
        currencyName: 'Somali Shilling',
        currencyAlphabeticCode: 'SOS',
        langName: 'Somali (Somalia)',
        langIso: 'so_SO',
    },
    {
        name: 'Somalia',
        officialName: 'Somalia',
        numeric: '706',
        alpha2: 'SO',
        alpha3: 'SOM',
        currencyName: 'Somali Shilling',
        currencyAlphabeticCode: 'SOS',
        langName: 'Italian (Somalia)',
        langIso: 'it_SO',
    },
    {
        name: 'South Africa',
        officialName: 'South Africa',
        numeric: '710',
        alpha2: 'ZA',
        alpha3: 'ZAF',
        currencyName: 'Rand',
        currencyAlphabeticCode: 'ZAR',
        langName: 'Zulu (South Africa)',
        langIso: 'zu_ZA',
    },
    {
        name: 'South Africa',
        officialName: 'South Africa',
        numeric: '710',
        alpha2: 'ZA',
        alpha3: 'ZAF',
        currencyName: 'Rand',
        currencyAlphabeticCode: 'ZAR',
        langName: 'Xhosa (South Africa)',
        langIso: 'xh_ZA',
    },
    {
        name: 'South Africa',
        officialName: 'South Africa',
        numeric: '710',
        alpha2: 'ZA',
        alpha3: 'ZAF',
        currencyName: 'Rand',
        currencyAlphabeticCode: 'ZAR',
        langName: 'Afrikaans (South Africa)',
        langIso: 'af_ZA',
    },
    {
        name: 'South Africa',
        officialName: 'South Africa',
        numeric: '710',
        alpha2: 'ZA',
        alpha3: 'ZAF',
        currencyName: 'Rand',
        currencyAlphabeticCode: 'ZAR',
        langName: 'Pedi (South Africa)',
        langIso: 'nso_ZA',
    },
    {
        name: 'South Africa',
        officialName: 'South Africa',
        numeric: '710',
        alpha2: 'ZA',
        alpha3: 'ZAF',
        currencyName: 'Rand',
        currencyAlphabeticCode: 'ZAR',
        langName: 'English (South Africa)',
        langIso: 'en_ZA',
    },
    {
        name: 'South Africa',
        officialName: 'South Africa',
        numeric: '710',
        alpha2: 'ZA',
        alpha3: 'ZAF',
        currencyName: 'Rand',
        currencyAlphabeticCode: 'ZAR',
        langName: 'Tswana (South Africa)',
        langIso: 'tn_ZA',
    },
    {
        name: 'South Africa',
        officialName: 'South Africa',
        numeric: '710',
        alpha2: 'ZA',
        alpha3: 'ZAF',
        currencyName: 'Rand',
        currencyAlphabeticCode: 'ZAR',
        langName: 'Southern Sotho (South Africa)',
        langIso: 'st_ZA',
    },
    {
        name: 'South Africa',
        officialName: 'South Africa',
        numeric: '710',
        alpha2: 'ZA',
        alpha3: 'ZAF',
        currencyName: 'Rand',
        currencyAlphabeticCode: 'ZAR',
        langName: 'Tsonga (South Africa)',
        langIso: 'ts_ZA',
    },
    {
        name: 'South Africa',
        officialName: 'South Africa',
        numeric: '710',
        alpha2: 'ZA',
        alpha3: 'ZAF',
        currencyName: 'Rand',
        currencyAlphabeticCode: 'ZAR',
        langName: 'Swati (South Africa)',
        langIso: 'ss_ZA',
    },
    {
        name: 'South Africa',
        officialName: 'South Africa',
        numeric: '710',
        alpha2: 'ZA',
        alpha3: 'ZAF',
        currencyName: 'Rand',
        currencyAlphabeticCode: 'ZAR',
        langName: 'Venda (South Africa)',
        langIso: 've_ZA',
    },
    {
        name: 'South Africa',
        officialName: 'South Africa',
        numeric: '710',
        alpha2: 'ZA',
        alpha3: 'ZAF',
        currencyName: 'Rand',
        currencyAlphabeticCode: 'ZAR',
        langName: 'South Ndebele (South Africa)',
        langIso: 'nr_ZA',
    },
    {
        name: 'South Georgia & South Sandwich Islands',
        officialName: 'South Georgia and the South Sandwich Islands',
        numeric: '239',
        alpha2: 'GS',
        alpha3: 'SGS',
        currencyName: 'No universal currency',
        currencyAlphabeticCode: null,
        langName: 'English (South Georgia & South Sandwich Islands)',
        langIso: 'en_GS',
    },
    {
        name: 'South Sudan',
        officialName: 'South Sudan',
        numeric: '728',
        alpha2: 'SS',
        alpha3: 'SSD',
        currencyName: 'South Sudanese Pound',
        currencyAlphabeticCode: 'SSP',
        langName: 'English (South Sudan)',
        langIso: 'en_SS',
    },
    {
        name: 'Spain',
        officialName: 'Spain',
        numeric: '724',
        alpha2: 'ES',
        alpha3: 'ESP',
        currencyName: 'Euro',
        currencyAlphabeticCode: 'EUR',
        langName: 'Catalan (Spain)',
        langIso: 'ca_ES',
    },
    {
        name: 'Spain',
        officialName: 'Spain',
        numeric: '724',
        alpha2: 'ES',
        alpha3: 'ESP',
        currencyName: 'Euro',
        currencyAlphabeticCode: 'EUR',
        langName: 'Galician (Spain)',
        langIso: 'gl_ES',
    },
    {
        name: 'Spain',
        officialName: 'Spain',
        numeric: '724',
        alpha2: 'ES',
        alpha3: 'ESP',
        currencyName: 'Euro',
        currencyAlphabeticCode: 'EUR',
        langName: 'Basque (Spain)',
        langIso: 'eu_ES',
    },
    {
        name: 'Spain',
        officialName: 'Spain',
        numeric: '724',
        alpha2: 'ES',
        alpha3: 'ESP',
        currencyName: 'Euro',
        currencyAlphabeticCode: 'EUR',
        langName: 'Occitan (Spain)',
        langIso: 'oc_ES',
    },
    {
        name: 'Sri Lanka',
        officialName: 'Sri Lanka',
        numeric: '144',
        alpha2: 'LK',
        alpha3: 'LKA',
        currencyName: 'Sri Lanka Rupee',
        currencyAlphabeticCode: 'LKR',
        langName: 'Sinhala (Sri Lanka)',
        langIso: 'si_LK',
    },
    {
        name: 'Sri Lanka',
        officialName: 'Sri Lanka',
        numeric: '144',
        alpha2: 'LK',
        alpha3: 'LKA',
        currencyName: 'Sri Lanka Rupee',
        currencyAlphabeticCode: 'LKR',
        langName: 'Tamil (Sri Lanka)',
        langIso: 'ta_LK',
    },
    {
        name: 'Sri Lanka',
        officialName: 'Sri Lanka',
        numeric: '144',
        alpha2: 'LK',
        alpha3: 'LKA',
        currencyName: 'Sri Lanka Rupee',
        currencyAlphabeticCode: 'LKR',
        langName: 'English (Sri Lanka)',
        langIso: 'en_LK',
    },
    {
        name: 'Sudan',
        officialName: 'Sudan',
        numeric: '729',
        alpha2: 'SD',
        alpha3: 'SDN',
        currencyName: 'Sudanese Pound',
        currencyAlphabeticCode: 'SDG',
        langName: 'Arabic (Sudan)',
        langIso: 'ar_SD',
    },
    {
        name: 'Sudan',
        officialName: 'Sudan',
        numeric: '729',
        alpha2: 'SD',
        alpha3: 'SDN',
        currencyName: 'Sudanese Pound',
        currencyAlphabeticCode: 'SDG',
        langName: 'English (Sudan)',
        langIso: 'en_SD',
    },
    {
        name: 'Suriname',
        officialName: 'Suriname',
        numeric: '740',
        alpha2: 'SR',
        alpha3: 'SUR',
        currencyName: 'Surinam Dollar',
        currencyAlphabeticCode: 'SRD',
        langName: 'English (Suriname)',
        langIso: 'en_SR',
    },
    {
        name: 'Suriname',
        officialName: 'Suriname',
        numeric: '740',
        alpha2: 'SR',
        alpha3: 'SUR',
        currencyName: 'Surinam Dollar',
        currencyAlphabeticCode: 'SRD',
        langName: 'Javanese (Suriname)',
        langIso: 'jv_SR',
    },
    {
        name: 'Svalbard & Jan Mayen',
        officialName: 'Svalbard and Jan Mayen Islands',
        numeric: '744',
        alpha2: 'SJ',
        alpha3: 'SJM',
        currencyName: 'Norwegian Krone',
        currencyAlphabeticCode: 'NOK',
        langName: 'Norwegian (Svalbard & Jan Mayen)',
        langIso: 'no_SJ',
    },
    {
        name: 'Svalbard & Jan Mayen',
        officialName: 'Svalbard and Jan Mayen Islands',
        numeric: '744',
        alpha2: 'SJ',
        alpha3: 'SJM',
        currencyName: 'Norwegian Krone',
        currencyAlphabeticCode: 'NOK',
        langName: 'Russian (Svalbard & Jan Mayen)',
        langIso: 'ru_SJ',
    },
    {
        name: 'Sweden',
        officialName: 'Sweden',
        numeric: '752',
        alpha2: 'SE',
        alpha3: 'SWE',
        currencyName: 'Swedish Krona',
        currencyAlphabeticCode: 'SEK',
        langName: 'Swedish (Sweden)',
        langIso: 'sv_SE',
    },
    {
        name: 'Sweden',
        officialName: 'Sweden',
        numeric: '752',
        alpha2: 'SE',
        alpha3: 'SWE',
        currencyName: 'Swedish Krona',
        currencyAlphabeticCode: 'SEK',
        langName: 'Northern Sami (Sweden)',
        langIso: 'se_SE',
    },
    {
        name: 'Switzerland',
        officialName: 'Switzerland',
        numeric: '756',
        alpha2: 'CH',
        alpha3: 'CHE',
        currencyName: 'Swiss Franc',
        currencyAlphabeticCode: 'CHF',
        langName: 'German (Switzerland)',
        langIso: 'de_CH',
    },
    {
        name: 'Switzerland',
        officialName: 'Switzerland',
        numeric: '756',
        alpha2: 'CH',
        alpha3: 'CHE',
        currencyName: 'Swiss Franc',
        currencyAlphabeticCode: 'CHF',
        langName: 'French (Switzerland)',
        langIso: 'fr_CH',
    },
    {
        name: 'Switzerland',
        officialName: 'Switzerland',
        numeric: '756',
        alpha2: 'CH',
        alpha3: 'CHE',
        currencyName: 'Swiss Franc',
        currencyAlphabeticCode: 'CHF',
        langName: 'Italian (Switzerland)',
        langIso: 'it_CH',
    },
    {
        name: 'Switzerland',
        officialName: 'Switzerland',
        numeric: '756',
        alpha2: 'CH',
        alpha3: 'CHE',
        currencyName: 'Swiss Franc',
        currencyAlphabeticCode: 'CHF',
        langName: 'Romansh (Switzerland)',
        langIso: 'rm_CH',
    },
    {
        name: 'Syria',
        officialName: 'Syrian Arab Republic',
        numeric: '760',
        alpha2: 'SY',
        alpha3: 'SYR',
        currencyName: 'Syrian Pound',
        currencyAlphabeticCode: 'SYP',
        langName: 'Arabic (Syria)',
        langIso: 'ar_SY',
    },
    {
        name: 'Syria',
        officialName: 'Syrian Arab Republic',
        numeric: '760',
        alpha2: 'SY',
        alpha3: 'SYR',
        currencyName: 'Syrian Pound',
        currencyAlphabeticCode: 'SYP',
        langName: 'Armenian (Syria)',
        langIso: 'hy_SY',
    },
    {
        name: 'Syria',
        officialName: 'Syrian Arab Republic',
        numeric: '760',
        alpha2: 'SY',
        alpha3: 'SYR',
        currencyName: 'Syrian Pound',
        currencyAlphabeticCode: 'SYP',
        langName: 'French (Syria)',
        langIso: 'fr_SY',
    },
    {
        name: 'Syria',
        officialName: 'Syrian Arab Republic',
        numeric: '760',
        alpha2: 'SY',
        alpha3: 'SYR',
        currencyName: 'Syrian Pound',
        currencyAlphabeticCode: 'SYP',
        langName: 'English (Syria)',
        langIso: 'en_SY',
    },
    {
        name: 'Tajikistan',
        officialName: 'Tajikistan',
        numeric: '762',
        alpha2: 'TJ',
        alpha3: 'TJK',
        currencyName: 'Somoni',
        currencyAlphabeticCode: 'TJS',
        langName: 'Tajik (Tajikistan)',
        langIso: 'tg_TJ',
    },
    {
        name: 'Tajikistan',
        officialName: 'Tajikistan',
        numeric: '762',
        alpha2: 'TJ',
        alpha3: 'TJK',
        currencyName: 'Somoni',
        currencyAlphabeticCode: 'TJS',
        langName: 'Russian (Tajikistan)',
        langIso: 'ru_TJ',
    },
    {
        name: 'Thailand',
        officialName: 'Thailand',
        numeric: '764',
        alpha2: 'TH',
        alpha3: 'THA',
        currencyName: 'Baht',
        currencyAlphabeticCode: 'THB',
        langName: 'Thai (Thailand)',
        langIso: 'th_TH',
    },
    {
        name: 'Thailand',
        officialName: 'Thailand',
        numeric: '764',
        alpha2: 'TH',
        alpha3: 'THA',
        currencyName: 'Baht',
        currencyAlphabeticCode: 'THB',
        langName: 'English (Thailand)',
        langIso: 'en_TH',
    },
    {
        name: 'North Macedonia',
        officialName: 'The former Yugoslav Republic of Macedonia',
        numeric: '807',
        alpha2: 'MK',
        alpha3: 'MKD',
        currencyName: 'Denar',
        currencyAlphabeticCode: 'MKD',
        langName: 'Albanian (North Macedonia)',
        langIso: 'sq_MK',
    },
    {
        name: 'North Macedonia',
        officialName: 'The former Yugoslav Republic of Macedonia',
        numeric: '807',
        alpha2: 'MK',
        alpha3: 'MKD',
        currencyName: 'Denar',
        currencyAlphabeticCode: 'MKD',
        langName: 'Turkish (North Macedonia)',
        langIso: 'tr_MK',
    },
    {
        name: 'North Macedonia',
        officialName: 'The former Yugoslav Republic of Macedonia',
        numeric: '807',
        alpha2: 'MK',
        alpha3: 'MKD',
        currencyName: 'Denar',
        currencyAlphabeticCode: 'MKD',
        langName: 'Serbian (North Macedonia)',
        langIso: 'sr_MK',
    },
    {
        name: 'Timor-Leste',
        officialName: 'Timor-Leste',
        numeric: '626',
        alpha2: 'TL',
        alpha3: 'TLS',
        currencyName: 'US Dollar',
        currencyAlphabeticCode: 'USD',
        langName: 'Indonesian (Timor-Leste)',
        langIso: 'id_TL',
    },
    {
        name: 'Timor-Leste',
        officialName: 'Timor-Leste',
        numeric: '626',
        alpha2: 'TL',
        alpha3: 'TLS',
        currencyName: 'US Dollar',
        currencyAlphabeticCode: 'USD',
        langName: 'English (Timor-Leste)',
        langIso: 'en_TL',
    },
    {
        name: 'Togo',
        officialName: 'Togo',
        numeric: '768',
        alpha2: 'TG',
        alpha3: 'TGO',
        currencyName: 'CFA Franc BCEAO',
        currencyAlphabeticCode: 'XOF',
        langName: 'French (Togo)',
        langIso: 'fr_TG',
    },
    {
        name: 'Togo',
        officialName: 'Togo',
        numeric: '768',
        alpha2: 'TG',
        alpha3: 'TGO',
        currencyName: 'CFA Franc BCEAO',
        currencyAlphabeticCode: 'XOF',
        langName: 'Ewe (Togo)',
        langIso: 'ee_TG',
    },
    {
        name: 'Togo',
        officialName: 'Togo',
        numeric: '768',
        alpha2: 'TG',
        alpha3: 'TGO',
        currencyName: 'CFA Franc BCEAO',
        currencyAlphabeticCode: 'XOF',
        langName: 'Hausa (Togo)',
        langIso: 'ha_TG',
    },
    {
        name: 'Tonga',
        officialName: 'Tonga',
        numeric: '776',
        alpha2: 'TO',
        alpha3: 'TON',
        currencyName: 'Pa’anga',
        currencyAlphabeticCode: 'TOP',
        langName: 'Tongan (Tonga)',
        langIso: 'to_TO',
    },
    {
        name: 'Trinidad & Tobago',
        officialName: 'Trinidad and Tobago',
        numeric: '780',
        alpha2: 'TT',
        alpha3: 'TTO',
        currencyName: 'Trinidad and Tobago Dollar',
        currencyAlphabeticCode: 'TTD',
        langName: 'English (Trinidad and Tobago)',
        langIso: 'en_TT',
    },
    {
        name: 'Trinidad & Tobago',
        officialName: 'Trinidad and Tobago',
        numeric: '780',
        alpha2: 'TT',
        alpha3: 'TTO',
        currencyName: 'Trinidad and Tobago Dollar',
        currencyAlphabeticCode: 'TTD',
        langName: 'French (Trinidad & Tobago)',
        langIso: 'fr_TT',
    },
    {
        name: 'Trinidad & Tobago',
        officialName: 'Trinidad and Tobago',
        numeric: '780',
        alpha2: 'TT',
        alpha3: 'TTO',
        currencyName: 'Trinidad and Tobago Dollar',
        currencyAlphabeticCode: 'TTD',
        langName: 'Spanish (Trinidad & Tobago)',
        langIso: 'es_TT',
    },
    {
        name: 'Tunisia',
        officialName: 'Tunisia',
        numeric: '788',
        alpha2: 'TN',
        alpha3: 'TUN',
        currencyName: 'Tunisian Dinar',
        currencyAlphabeticCode: 'TND',
        langName: 'Arabic (Tunisia)',
        langIso: 'ar_TN',
    },
    {
        name: 'Tunisia',
        officialName: 'Tunisia',
        numeric: '788',
        alpha2: 'TN',
        alpha3: 'TUN',
        currencyName: 'Tunisian Dinar',
        currencyAlphabeticCode: 'TND',
        langName: 'French (Tunisia)',
        langIso: 'fr_TN',
    },
    {
        name: 'Turkey',
        officialName: 'Turkey',
        numeric: '792',
        alpha2: 'TR',
        alpha3: 'TUR',
        currencyName: 'Turkish Lira',
        currencyAlphabeticCode: 'TRY',
        langName: 'Turkish (Turkey)',
        langIso: 'tr_TR',
    },
    {
        name: 'Turkey',
        officialName: 'Turkey',
        numeric: '792',
        alpha2: 'TR',
        alpha3: 'TUR',
        currencyName: 'Turkish Lira',
        currencyAlphabeticCode: 'TRY',
        langName: 'Azerbaijani (Turkey)',
        langIso: 'az_TR',
    },
    {
        name: 'Turkey',
        officialName: 'Turkey',
        numeric: '792',
        alpha2: 'TR',
        alpha3: 'TUR',
        currencyName: 'Turkish Lira',
        currencyAlphabeticCode: 'TRY',
        langName: 'Avaric (Turkey)',
        langIso: 'av_TR',
    },
    {
        name: 'Turkmenistan',
        officialName: 'Turkmenistan',
        numeric: '795',
        alpha2: 'TM',
        alpha3: 'TKM',
        currencyName: 'Turkmenistan New Manat',
        currencyAlphabeticCode: 'TMT',
        langName: 'Turkmen (Turkmenistan)',
        langIso: 'tk_TM',
    },
    {
        name: 'Turkmenistan',
        officialName: 'Turkmenistan',
        numeric: '795',
        alpha2: 'TM',
        alpha3: 'TKM',
        currencyName: 'Turkmenistan New Manat',
        currencyAlphabeticCode: 'TMT',
        langName: 'Russian (Turkmenistan)',
        langIso: 'ru_TM',
    },
    {
        name: 'Turkmenistan',
        officialName: 'Turkmenistan',
        numeric: '795',
        alpha2: 'TM',
        alpha3: 'TKM',
        currencyName: 'Turkmenistan New Manat',
        currencyAlphabeticCode: 'TMT',
        langName: 'Uzbek (Turkmenistan)',
        langIso: 'uz_TM',
    },
    {
        name: 'Tuvalu',
        officialName: 'Tuvalu',
        numeric: '798',
        alpha2: 'TV',
        alpha3: 'TUV',
        currencyName: 'Australian Dollar',
        currencyAlphabeticCode: 'AUD',
        langName: 'English (Tuvalu)',
        langIso: 'en_TV',
    },
    {
        name: 'Tuvalu',
        officialName: 'Tuvalu',
        numeric: '798',
        alpha2: 'TV',
        alpha3: 'TUV',
        currencyName: 'Australian Dollar',
        currencyAlphabeticCode: 'AUD',
        langName: 'Samoan (Tuvalu)',
        langIso: 'sm_TV',
    },
    {
        name: 'Uganda',
        officialName: 'Uganda',
        numeric: '800',
        alpha2: 'UG',
        alpha3: 'UGA',
        currencyName: 'Uganda Shilling',
        currencyAlphabeticCode: 'UGX',
        langName: 'Ganda (Uganda)',
        langIso: 'lg_UG',
    },
    {
        name: 'Uganda',
        officialName: 'Uganda',
        numeric: '800',
        alpha2: 'UG',
        alpha3: 'UGA',
        currencyName: 'Uganda Shilling',
        currencyAlphabeticCode: 'UGX',
        langName: 'Swahili (Uganda)',
        langIso: 'sw_UG',
    },
    {
        name: 'Uganda',
        officialName: 'Uganda',
        numeric: '800',
        alpha2: 'UG',
        alpha3: 'UGA',
        currencyName: 'Uganda Shilling',
        currencyAlphabeticCode: 'UGX',
        langName: 'Arabic (Uganda)',
        langIso: 'ar_UG',
    },
    {
        name: 'Ukraine',
        officialName: 'Ukraine',
        numeric: '804',
        alpha2: 'UA',
        alpha3: 'UKR',
        currencyName: 'Hryvnia',
        currencyAlphabeticCode: 'UAH',
        langName: 'Ukrainian (Ukraine)',
        langIso: 'uk_UA',
    },
    {
        name: 'Ukraine',
        officialName: 'Ukraine',
        numeric: '804',
        alpha2: 'UA',
        alpha3: 'UKR',
        currencyName: 'Hryvnia',
        currencyAlphabeticCode: 'UAH',
        langName: 'Russian (Ukraine)',
        langIso: 'ru_UA',
    },
    {
        name: 'Ukraine',
        officialName: 'Ukraine',
        numeric: '804',
        alpha2: 'UA',
        alpha3: 'UKR',
        currencyName: 'Hryvnia',
        currencyAlphabeticCode: 'UAH',
        langName: 'Polish (Ukraine)',
        langIso: 'pl_UA',
    },
    {
        name: 'Ukraine',
        officialName: 'Ukraine',
        numeric: '804',
        alpha2: 'UA',
        alpha3: 'UKR',
        currencyName: 'Hryvnia',
        currencyAlphabeticCode: 'UAH',
        langName: 'Hungarian (Ukraine)',
        langIso: 'hu_UA',
    },
    {
        name: 'United Arab Emirates',
        officialName: 'United Arab Emirates',
        numeric: '784',
        alpha2: 'AE',
        alpha3: 'ARE',
        currencyName: 'UAE Dirham',
        currencyAlphabeticCode: 'AED',
        langName: 'Arabic (United Arab Emirates)',
        langIso: 'ar_AE',
    },
    {
        name: 'United Arab Emirates',
        officialName: 'United Arab Emirates',
        numeric: '784',
        alpha2: 'AE',
        alpha3: 'ARE',
        currencyName: 'UAE Dirham',
        currencyAlphabeticCode: 'AED',
        langName: 'Persian (United Arab Emirates)',
        langIso: 'fa_AE',
    },
    {
        name: 'United Arab Emirates',
        officialName: 'United Arab Emirates',
        numeric: '784',
        alpha2: 'AE',
        alpha3: 'ARE',
        currencyName: 'UAE Dirham',
        currencyAlphabeticCode: 'AED',
        langName: 'English (United Arab Emirates)',
        langIso: 'en_AE',
    },
    {
        name: 'United Arab Emirates',
        officialName: 'United Arab Emirates',
        numeric: '784',
        alpha2: 'AE',
        alpha3: 'ARE',
        currencyName: 'UAE Dirham',
        currencyAlphabeticCode: 'AED',
        langName: 'Hindi (United Arab Emirates)',
        langIso: 'hi_AE',
    },
    {
        name: 'United Arab Emirates',
        officialName: 'United Arab Emirates',
        numeric: '784',
        alpha2: 'AE',
        alpha3: 'ARE',
        currencyName: 'UAE Dirham',
        currencyAlphabeticCode: 'AED',
        langName: 'Urdu (United Arab Emirates)',
        langIso: 'ur_AE',
    },
    {
        name: 'UK',
        officialName: 'United Kingdom of Great Britain and Northern Ireland',
        numeric: '826',
        alpha2: 'GB',
        alpha3: 'GBR',
        currencyName: 'Pound Sterling',
        currencyAlphabeticCode: 'GBP',
        langName: 'English (United Kingdom)',
        langIso: 'en_GB',
    },
    {
        name: 'UK',
        officialName: 'United Kingdom of Great Britain and Northern Ireland',
        numeric: '826',
        alpha2: 'GB',
        alpha3: 'GBR',
        currencyName: 'Pound Sterling',
        currencyAlphabeticCode: 'GBP',
        langName: 'Welsh (United Kingdom)',
        langIso: 'cy_GB',
    },
    {
        name: 'UK',
        officialName: 'United Kingdom of Great Britain and Northern Ireland',
        numeric: '826',
        alpha2: 'GB',
        alpha3: 'GBR',
        currencyName: 'Pound Sterling',
        currencyAlphabeticCode: 'GBP',
        langName: 'Scottish Gaelic (UK)',
        langIso: 'gd_GB',
    },
    {
        name: 'Tanzania',
        officialName: 'United Republic of Tanzania',
        numeric: '834',
        alpha2: 'TZ',
        alpha3: 'TZA',
        currencyName: 'Tanzanian Shilling',
        currencyAlphabeticCode: 'TZS',
        langName: 'Swahili (Tanzania)',
        langIso: 'sw_TZ',
    },
    {
        name: 'Tanzania',
        officialName: 'United Republic of Tanzania',
        numeric: '834',
        alpha2: 'TZ',
        alpha3: 'TZA',
        currencyName: 'Tanzanian Shilling',
        currencyAlphabeticCode: 'TZS',
        langName: 'English (Tanzania)',
        langIso: 'en_TZ',
    },
    {
        name: 'Tanzania',
        officialName: 'United Republic of Tanzania',
        numeric: '834',
        alpha2: 'TZ',
        alpha3: 'TZA',
        currencyName: 'Tanzanian Shilling',
        currencyAlphabeticCode: 'TZS',
        langName: 'Arabic (Tanzania)',
        langIso: 'ar_TZ',
    },
    {
        name: 'U.S. Outlying Islands',
        officialName: 'United States Minor Outlying Islands',
        numeric: '581',
        alpha2: 'UM',
        alpha3: 'UMI',
        currencyName: 'US Dollar',
        currencyAlphabeticCode: 'USD',
        langName: 'English (U.S. Minor Outlying Islands)',
        langIso: 'en_UM',
    },
    {
        name: 'U.S. Virgin Islands',
        officialName: 'United States Virgin Islands',
        numeric: '850',
        alpha2: 'VI',
        alpha3: 'VIR',
        currencyName: 'US Dollar',
        currencyAlphabeticCode: 'USD',
        langName: 'English (U.S. Virgin Islands)',
        langIso: 'en_VI',
    },
    {
        name: 'US',
        officialName: 'United States of America',
        numeric: '840',
        alpha2: 'US',
        alpha3: 'USA',
        currencyName: 'US Dollar',
        currencyAlphabeticCode: 'USD',
        langName: 'Spanish (United States)',
        langIso: 'es_US',
    },
    {
        name: 'US',
        officialName: 'United States of America',
        numeric: '840',
        alpha2: 'US',
        alpha3: 'USA',
        currencyName: 'US Dollar',
        currencyAlphabeticCode: 'USD',
        langName: 'Hawaiian (US)',
        langIso: 'haw_US',
    },
    {
        name: 'US',
        officialName: 'United States of America',
        numeric: '840',
        alpha2: 'US',
        alpha3: 'USA',
        currencyName: 'US Dollar',
        currencyAlphabeticCode: 'USD',
        langName: 'French (US)',
        langIso: 'fr_US',
    },
    {
        name: 'Uruguay',
        officialName: 'Uruguay',
        numeric: '858',
        alpha2: 'UY',
        alpha3: 'URY',
        currencyName: 'Peso Uruguayo',
        currencyAlphabeticCode: 'UYU',
        langName: 'Spanish (Uruguay)',
        langIso: 'es_UY',
    },
    {
        name: 'Uzbekistan',
        officialName: 'Uzbekistan',
        numeric: '860',
        alpha2: 'UZ',
        alpha3: 'UZB',
        currencyName: 'Uzbekistan Sum',
        currencyAlphabeticCode: 'UZS',
        langName: 'Uzbek (Uzbekistan)',
        langIso: 'uz_UZ',
    },
    {
        name: 'Uzbekistan',
        officialName: 'Uzbekistan',
        numeric: '860',
        alpha2: 'UZ',
        alpha3: 'UZB',
        currencyName: 'Uzbekistan Sum',
        currencyAlphabeticCode: 'UZS',
        langName: 'Russian (Uzbekistan)',
        langIso: 'ru_UZ',
    },
    {
        name: 'Uzbekistan',
        officialName: 'Uzbekistan',
        numeric: '860',
        alpha2: 'UZ',
        alpha3: 'UZB',
        currencyName: 'Uzbekistan Sum',
        currencyAlphabeticCode: 'UZS',
        langName: 'Tajik (Uzbekistan)',
        langIso: 'tg_UZ',
    },
    {
        name: 'Vanuatu',
        officialName: 'Vanuatu',
        numeric: '548',
        alpha2: 'VU',
        alpha3: 'VUT',
        currencyName: 'Vatu',
        currencyAlphabeticCode: 'VUV',
        langName: 'Bislama (Vanuatu)',
        langIso: 'bi_VU',
    },
    {
        name: 'Venezuela',
        officialName: 'Venezuela (Bolivarian Republic of)',
        numeric: '862',
        alpha2: 'VE',
        alpha3: 'VEN',
        currencyName: 'Bolívar',
        currencyAlphabeticCode: 'VES',
        langName: 'Spanish (Venezuela)',
        langIso: 'es_VE',
    },
    {
        name: 'Vietnam',
        officialName: 'Viet Nam',
        numeric: '704',
        alpha2: 'VN',
        alpha3: 'VNM',
        currencyName: 'Dong',
        currencyAlphabeticCode: 'VND',
        langName: 'Vietnamese (Vietnam)',
        langIso: 'vi_VN',
    },
    {
        name: 'Vietnam',
        officialName: 'Viet Nam',
        numeric: '704',
        alpha2: 'VN',
        alpha3: 'VNM',
        currencyName: 'Dong',
        currencyAlphabeticCode: 'VND',
        langName: 'English (Vietnam)',
        langIso: 'en_VN',
    },
    {
        name: 'Vietnam',
        officialName: 'Viet Nam',
        numeric: '704',
        alpha2: 'VN',
        alpha3: 'VNM',
        currencyName: 'Dong',
        currencyAlphabeticCode: 'VND',
        langName: 'French (Vietnam)',
        langIso: 'fr_VN',
    },
    {
        name: 'Western Sahara',
        officialName: 'Western Sahara',
        numeric: '732',
        alpha2: 'EH',
        alpha3: 'ESH',
        currencyName: 'Moroccan Dirham',
        currencyAlphabeticCode: 'MAD',
        langName: 'Arabic (Western Sahara)',
        langIso: 'ar_EH',
    },
    {
        name: 'Yemen',
        officialName: 'Yemen',
        numeric: '887',
        alpha2: 'YE',
        alpha3: 'YEM',
        currencyName: 'Yemeni Rial',
        currencyAlphabeticCode: 'YER',
        langName: 'Arabic (Yemen)',
        langIso: 'ar_YE',
    },
    {
        name: 'Zambia',
        officialName: 'Zambia',
        numeric: '894',
        alpha2: 'ZM',
        alpha3: 'ZMB',
        currencyName: 'Zambian Kwacha',
        currencyAlphabeticCode: 'ZMW',
        langName: 'Bemba (Zambia)',
        langIso: 'bem_ZM',
    },
    {
        name: 'Zambia',
        officialName: 'Zambia',
        numeric: '894',
        alpha2: 'ZM',
        alpha3: 'ZMB',
        currencyName: 'Zambian Kwacha',
        currencyAlphabeticCode: 'ZMW',
        langName: 'Chichewa (Zambia)',
        langIso: 'ny_ZM',
    },
    {
        name: 'Zimbabwe',
        officialName: 'Zimbabwe',
        numeric: '716',
        alpha2: 'ZW',
        alpha3: 'ZWE',
        currencyName: 'Zimbabwe Dollar',
        currencyAlphabeticCode: 'ZWL',
        langName: 'English (Zimbabwe)',
        langIso: 'en_ZW',
    },
    {
        name: 'Zimbabwe',
        officialName: 'Zimbabwe',
        numeric: '716',
        alpha2: 'ZW',
        alpha3: 'ZWE',
        currencyName: 'Zimbabwe Dollar',
        currencyAlphabeticCode: 'ZWL',
        langName: 'Shona (Zimbabwe)',
        langIso: 'sn_ZW',
    },
    {
        name: 'Zimbabwe',
        officialName: 'Zimbabwe',
        numeric: '716',
        alpha2: 'ZW',
        alpha3: 'ZWE',
        currencyName: 'Zimbabwe Dollar',
        currencyAlphabeticCode: 'ZWL',
        langName: 'South Ndebele (Zimbabwe)',
        langIso: 'nr_ZW',
    },
    {
        name: 'Zimbabwe',
        officialName: 'Zimbabwe',
        numeric: '716',
        alpha2: 'ZW',
        alpha3: 'ZWE',
        currencyName: 'Zimbabwe Dollar',
        currencyAlphabeticCode: 'ZWL',
        langName: 'North Ndebele (Zimbabwe)',
        langIso: 'nd_ZW',
    },
];
//# sourceMappingURL=locales.js.map